import emojiPickerI18n from '@web-lite/emoji-mart-data/i18n/fa.json'
import { LIMITS } from '@weblite/permission'
import { toLocale } from '$helper/functions/text'
import {
  getMessageToken,
  getTextToken,
  getUserToken,
} from '$comp/_app/components/chat/components/body/components/messageList/components/event/react-hook.helper'
import { boldSome } from '$comp/modals/confirmation-dialog/confirmation-dialog.helper'
import { dateTimeFormatter } from '$helper/functions/time'
import { LanguageType } from '../type'
import { FRONT_HOST, TWA_DOWNLOAD_SRC } from '$setup/local-language/constants'

const APP_NAME = 'پنل کاربری آلفا اسکول'

export const translationPersian: LanguageType = {
  serverError: 'مشکلی در ارتباط با سرور پیش آمده است',
  common: {
    add: 'افزودن',
    signup: 'ثبت نام',
    optional: 'اختیاری',
    pass: 'رد شدن',
    new: 'جدید',
    uploading: 'در حال بارگذاری',
    you: 'شما',
    from: 'از',
    ok: 'تأیید',
    newChat: 'گفتگو جدید',
    cancel: 'لغو',
    notifications: 'اعلان‌ها',
    loading: 'در حال دریافت...',
    search: 'جستجو...',
    termsAndConditions: 'شرایط و قوانین',
    register: 'ثبت',
    refuse: 'انصراف',
    retry: 'تلاش مجدد',
    admin: 'مدیر',
    etc: 'غیره',
    owner: 'مالک',
    close: 'بستن',
    online: 'آنلاین',
    group: 'گروه',
    channel: 'کانال',
    settings: 'تنظیمات',
    skip: 'رد کردن',
    subscriber: 'مشترک',
    member: 'عضو',
    edit: 'ویرایش',
    confirm: 'تأیید',
    remove: 'حذف',
    save: 'ذخیره',
    back: 'بازگشت',
    unlimited: 'نامحدود',
    revert: 'بازگردانی',

    thousand: 'هزار',
    million: 'میلیون',
    billion: 'میلیارد',

    second: 'ثانیه',
    minute: 'دقیقه',
    hour: 'ساعت',

    B: 'بایت',
    KB: 'کیلوبایت',
    MB: 'مگابایت',
    GB: 'گیگابایت',

    male: 'مرد',
    female: 'زن',

    today: 'امروز',
    yesterday: 'دیروز',
    soon: 'بزودی!',
    and: ' و ',
    resume: 'ادامه',
    understand: 'متوجه شدم',
    live: 'زنده',

    privateChannel: 'کانال خصوصی',

    dateFormats: {
      timeDay: (day, time) => `ساعت ${time} روز ${day}`,
      now: 'همین الان',
      nYearsAgo: (n: number) => `${n} سال قبل`,
      nMonthsAgo: (n: number) => `${n} ماه قبل`,
      nDaysAgo: n => `${n} روز قبل`,
      nHoursAgo: (n: number) => `${n} ساعت قبل`,
      nMinutesAgo: (n: number) => `${n} دقیقه قبل`,
      nYears: n => `${toLocale(n)} سال`,
      nMonths: n => `${toLocale(n)} ماه`,
      nWeeks: n => `${toLocale(n)} هفته`,
      nDays: n => `${toLocale(n)} روز`,
      nHours: n => `${toLocale(n)} ساعت`,
      nMinutes: n => `${toLocale(n)} دقیقه`,
      nSeconds: n => `${toLocale(n)} ثانیه`,
    },
    deactive: 'غیر فعال کردن',
    reload: 'بارگذاری مجدد', // TODO
  },
  symbols: {
    openingDoubleQuotation: '»',
    closingDoubleQuotation: '«',
  },
  joinClassField: {
    title: 'لینک عضویت در کلاس',
    placeholder: 'لینک خود را وارد کنید',
    submitText: 'عضویت',
    invalidLinkError: (remainingSeconds: number) =>
      `لینک نامعتبر است. ${toLocale(
        remainingSeconds,
      )} ثانیه دیگر دوباره امتحان کنید.`,
  },
  connectionStatus: {
    connecting: 'در حال اتصال...',
    updating: 'در حال همگام‌سازی...',
    waitingForNetwork: 'در انتظار شبکه...',
    willReconnect: (delay: number) =>
      `اتصال مجدد در ${toLocale(delay, false)} ثانیه`,
  },
  user: {
    name: 'نام',
    lastName: 'نام خانوادگی',
    phone: 'شماره‌ی همراه',
    username: 'نام کاربری',
    bio: 'معرفی کوتاه',
    id: 'شناسه',
    enterName: 'نام را وارد کنید',
    enterLastName: 'نام خانوادگی را وارد کنید',
    educationPlace: 'محل تحصیل',
    status: {
      online: 'آنلاین',
      recently: 'آخرین بازدید به تازگی',
      withinAWeek: 'آخرین بازدید در هفته‌ی اخیر',
      withinAMonth: 'آخرین بازدید در یک ماه اخیر',
      aLongTimeAgo: 'آخرین بازدید خیلی وقت پیش',
      lastSeenAt: 'آخرین بازدید در ',
      lastSeenYesterday: 'آخرین بازدید دیروز در ',
    },
  },
  menu: {
    roomProfile: {
      viewProfile: 'مشاهده عکس پروفایل',
      viewStory: 'ورود به اطلاع رسانی',
    },
    profileImage: {
      newImage: 'بارگذاری عکس',
      replaceImage: 'بارگذاری عکس جایگزین',
      deleteCurrent: 'حذف عکس فعلی',
    },
    blockedUsers: {
      unblocking: 'رفع مسدودیت',
    },
    exceptionUser: {
      removeFromList: 'حذف از فهرست',
    },
    phone: {
      call: 'تماس',
      callThroughNetwork: 'تماس از طریق شبکه',
      copy: 'رونوشت',
      sendMessage: 'ارسال پیام',
      callThroughApp: `تماس ${APP_NAME}`,
      callThroughPhone: 'تماس از طریق تلفن همراه',
    },
    link: {
      open: 'باز کردن',
    },
    hall: {
      leaveGroup: 'ترک گروه',
      leaveChannel: 'ترک کانال',
      adminLeaveGroup: 'ترک و حذف گروه',
      removeFromGroup: 'حذف از گروه',
      removeFromChannel: 'حذف از کانال',
      editAdminRights: 'ویرایش اختیارات مدیر',
      editRights: 'تغییر اختیارات',
      promote: 'ارتقا به مدیر',
      dismissAdmin: 'برکناری مدیر',
    },

    common: {
      removeChat: 'حذف گفت‌وگو',
      clearHistory: 'پاک‌سازی تاریخچه',
      markAsRead: 'علامت زدن به عنوان خوانده شده',
      markAsUnread: 'علامت زدن به عنوان خوانده نشده',
      copy: 'کپی',
      select: 'انتخاب',
      share: 'به اشتراک گذاری',
      report: 'گزارش محتوای نامناسب',
      remove: 'حذف',
    },

    call: {
      getAttendanceReport: 'لیست شرکت‌کنندگان',
    },
    admin: { editRights: 'تغییر', dismissAdmin: 'صرف نظر' },
    removedUser: {
      addToChannel: 'افزودن به کانال',
      addToGroup: 'افزودن به گروه',
      delete: 'حذف از فهرست',
    },
    inviteLink: {
      edit: 'ویرایش لینک',
      revoke: 'باطل کردن لینک',
      remove: 'حذف لینک',
    },
  },
  navigationBar: {
    chat: 'گفتگو',
    profile: 'پروفایل',
    generalIssue: 'رفع اشکال',
    workbench: 'میزکار',
    vitrine: 'ویترین',
    workInProgress: 'این صفحه در حال توسعه است و به زودی از آن رونمایی می‌شود!',
  },

  JoinHallRequests: {
    requestsBarTitle: (count: number, type) =>
      `${toLocale(count, false)} درخواست برای عضویت در ${
        type === 'CHANNEL' ? 'کانال' : 'گروه'
      }`,
    list: {
      title: 'درخواست عضویت',
      emptyText: type =>
        `درخواستی برای عضویت در ${
          type === 'CHANNEL' ? 'کانال' : 'گروه'
        } وجود ندارد`,
      requestedToJoinAt: 'درخواست داده شده در',
      errorText: 'دریافت لیست درخواست‌ها با مشکل مواجه شد',
    },
  },

  appBar: {
    search: 'جستجو...',
  },

  story: {
    official: 'رسمی',
    nStories: n => `${n} اطلاع رسانی`,
    stories: 'اطلاع رسانی‌ها',
    addStory: 'افزودن اطلاع رسانی',
    yourStory: 'اطلاع رسانی شما',
    createStoryModal: {
      chooseOneOfBelowOptions: 'یکی از گزینه‌های زیر را انتخاب کنید',
      storyTypes: {
        image: 'عکس',
        video: 'فیلم',
      },
      submit: 'تایید و ارسال',
    },
    viewStoryModal: {
      addStory: 'افزودن اطلاع رسانی',
      deleteStory: 'حذف اطلاع رسانی',
    },
    deleteStoryModal: {
      title: 'حدف اطلاع رسانی',
      description: 'آیا از حذف این اطلاع رسانی اطمینان دارید؟',
    },
    noViewedYet: 'هنوز بازدیدی ثبت نشده است',
    sending: 'در حال ارسال',
  },

  syncIOSAccounts: {
    onboarding: {
      title: `برای دسترسی به مخاطبین ${APP_NAME} در iOS، باید از این طریق مخاطبین خود را انتخاب کنید.`,
    },
    fabButtonLabel: 'بروزرسانی مخاطبین',
    nContactsDoesntHaveAppAccount: n =>
      `${toLocale(
        n,
        false,
      )} مخاطب انتخاب شده در ${APP_NAME} حساب کاربری ندارند`,
    selectedContactDoesntHaveAppAccount: `مخاطب انتخاب شده در ${APP_NAME} حساب کاربری ندارد`,
    xAddedToContacts: name => `«${name}» به مخاطبین اضافه شد`,
    xAndNPersonsAddedToContacts: (name, n) =>
      `«${name}» و ${toLocale(n, false)} نفر دیگر به مخاطبین اضافه شدند`,
    howToEnableSyncDialog: {
      title: `برای دسترسی به مخاطبین ${APP_NAME} در iOS، ابتدا باید مراحل زیر را انجام دهید:`,
      steps: {
        first: 'وارد Settings گوشی خود شوید.',
        second: 'از بین برنامه‌ها Safari را انتخاب کنید.',
        third: 'در انتهای صفحه Advanced را انتخاب کنید.',
        fourth: 'گزینه Feature Flags را انتخاب کنید.',
        fifth: 'گزینه Contact Picker API را فعال کنید.',
        sixth: `برنامه ${APP_NAME} را کامل بسته و مجدد باز کنید.`,
      },
      confirm: 'متوجه شدم',
    },
  },

  profile: {
    hall: {
      deletedChannel: 'کانال حذف شده',
      deletedGroup: 'گروه حذف شده',
      inviteLink: 'لینک دعوت',
      description: 'توضیحات',
      subscriber: 'مشترک',
      member: 'عضو',
      channelName: 'عنوان کانال',
      groupName: 'عنوان گروه',
      enterChannelName: 'عنوان کانال را وارد کنید',
      enterGroupName: 'عنوان گروه را وارد کنید',
      enterChannelDescription: 'توضیحات مربوط به کانال را وارد کنید',
      enterGroupDescription: 'توضیحات مربوط به گروه را وارد کنید',
      noDescription: 'توضیحاتی وجود ندارد',
      channelVitrine: 'ویترین کانال',
      options: {
        type: {
          groupType: 'نوع گروه',
          channelType: 'نوع کانال',
          private: 'خصوصی',
          public: 'عمومی',
        },
        historyForNewMembers: {
          title: 'تاریخچه گفت‌وگو برای اعضای جدید',
          visible: 'قابل مشاهده',
          hidden: 'پنهان',
        },
      },
      actions: {
        inviteViaLink: 'دعوت از طریق لینک',
        setting: 'تنظیمات',
        addMember: 'افزودن عضو',
        joinChannel: 'پیوستن به کانال',
        joinGroup: 'پیوستن به گروه',
        subscribers: 'مشترکین',
        members: 'اعضای گروه',
        admins: 'مدیران',
        addSubscriber: 'افزودن مشترک',
        membersPermissions: 'اختیارات اعضا',
        inviteLinks: 'لینک‌های دعوت',
        removedUsers: 'کاربران حذف شده',
        joinRequests: 'درخواست‌های عضویت',
      },
      criticalActions: {
        deleteChannel: 'حذف کانال',
        deleteGroup: 'حذف و ترک گروه',
      },
      removeUsers: { title: 'حذف کاربر', removedBy: 'حذف شده توسط' },
      joinedViaLink: {
        title: 'افراد پیوسته از طریق لینک',
      },
    },
    user: {
      sendMessage: 'ارسال پیام',
      block: 'مسدود کردن کاربر',
      unblock: 'رفع مسدودیت کاربر',
      deleteContact: 'حذف مخاطب',
      addToContacts: 'افزودن به مخاطبین',
      deleteConversation: 'حذف گفت‌وگو',
      clearHistory: 'پاک کردن تاریخچه',
    },
    wapp: {
      sendMessage: 'مشاهده‌ی گفت‌وگو',
      tool: 'ابزار',
    },
    common: {
      sharedMedia: 'رسانه‌های اشتراکی',
    },
    notification: {
      active: 'فعال',
      passive: 'غیرفعال',
    },
  },
  multiTab: {
    refresh: 'فعال کردن این صفحه',
    error: 'این صفحه غیرفعال شد',
    description:
      'شما صفحه دیگری از برنامه را باز کرده‌اید. بنابراین برای جلوگیری از مشکلات احتمالی، ما این صفحه را غیرفعال کرده‌ایم.',
  },
  myAccount: {
    plans: 'نسخه ویژه',
    usageDashboard: 'وضعیت مصرف اشتراک',
    account: 'حساب کاربری',
    version: version => `نسخه ${version}`,
    contact: 'مخاطبین',
    contactUs: 'ارتباط با ما',
    balance: 'اطلاعات مالی',
    credit: 'اعتبار:',
    savedMessage: 'پیام‌های ذخیره شده',
    savedMessageDesc: 'محلی برای ذخیره پیام‌های شما...',
    privacyRules: 'قوانین حریم شخصی',
    inviteFriends: 'دعوت از دوستان',
    support: `پشتیبانی ${APP_NAME}`,
    logout: 'خروج',
    addUserName: 'برای این حساب نام کاربری انتخاب کنید',
    addBio: 'خودتان را کوتاه معرفی کنید',
    blockedUsers: {
      block: 'مسدود کردن کاربر', // TODO: Merge block titles
    },
    base: 'مقطع تحصیلی',
    faq: 'سوالات متداول',
    q1: {
      title: `پلتفرم ${APP_NAME} چیست؟`,
      description:
        'پنل کاربری آلفا اسکول پلتفرمی تخصصی برای برگزاری دوره‌های آنلاین است. این پلتفرم که بر پایه پیام‌رسان است، تمامی خدمات و ابزارهای لازم برای برگزاری یک دوره آنلاین را با بالاترین کیفیت و به صورت یکپارچه با داخل پیام‌رسان در اختیار مجموعه یا معلم قرار می‌دهد. ابزارهایی همچون کلاس آنلاین، آزمون تستی و تشریحی، نظرسنجی، تک‌تست و … از جمله این ابزارها هستند.',
    },
    q2: {
      title: `چگونه ${APP_NAME} را روی موبایل و تبلت نصب کنم؟`,
      description:
        'در حال حاضر تنها اپلیکیشن اندروید وجود دارد که آخرین نسخه آن را از بازار یا مایکت می‌توانید دریافت نمایید.\n' +
        '\n' +
        'برای سیستم‌عامل‌های دیگر مثل iOS، ویندوز، macOS و لینوکس می‌توانید از نسخه PWA که در آدرس https://weblite.me قرار دارد، استفاده نمایید.',
    },
    q3: {
      title: `چگونه ${APP_NAME} را روی کامپیوتر شخصی داشته باشم؟`,
      description:
        'برای دسترسی به پنل کاربری آلفا اسکول روی کامپیوتر شخصی و لپ تاپ می‌توانید از نسخه وب پنل کاربری آلفا اسکول که در آدرس  https://weblite.me وجود دارد استفاده نمایید.',
    },
    q4: {
      title: 'چگونه گروه یا کانال ایجاد کنم؟',
      description:
        'در صفحه گفت‌گو بر روی آیکون مداد کلیک نمایید و از لیست موجود گزینه ایجاد گروه یا ایجاد کانال را انتخاب نمایید. سپس در صفحه بعدی می‌بایست مشخصات گروه یا کانال که شامل نام، نوع، شناسه و توضیحات است را وارد کنید. در مرحله بعد مخاطبینی که تمایل دارید در گروه یا کانال شما عضو شوند را از لیست مخاطبان انتخاب نموده و با تایید نهایی گروه یا کانال مدنظر شما ایجاد می‌گردد.',
    },
    q5: {
      title: 'چگونه مطلع شوم چه دستگاه‌هایی به اکانت من متصل هستند؟',
      description:
        'برای اطلاع از لیست دستگاه‌های فعال؛ کافی است وارد بخش تنظیمات شده و از زیربخش امنیت، گزینه دستگاه‌های فعال را انتخاب نمایید. در صفحه جدید میتوانید لیست کاملی از دستگاه‌های متصل به حساب کاربری خود را مشاهده نمایید.\n' +
        '\n' +
        ' اگر دستگاهی متعلق به شما نبود و در لیست قرار داشت، می‌توانید به آسانی و با انتخاب حذف دستگاه؛ این دستگاه ناشناس را از لیست دستگاه‌های فعال حذف نمایید تا دسترسی آن به حساب کاربری شما بسته شود.\n',
    },
    q6: {
      title: 'آیا شماره تلفن من برای دیگران قابل مشاهده است؟',
      description:
        'شماره تلفن همراه شما برای هیچ کس قابل مشاهده و دسترسی نیست؛ مگر اینکه از قبل شماره تلفن همراه شما را ذخیره داشته باشند.',
    },
    q7: {
      title: 'چگونه یک کاربر را به لیست سیاه اضافه نمایم؟',
      description:
        'بعد از ورود به صفحه مکالمات با شخص مورد نظر؛ روی نام مخاطب در بالای صفحه کلیک نمایید تا صفحه پروفایل کاربر باز شود. از طریق منویی که در بالا سمت چپ باز می‌شود، می‌توانید گزینه مسدود کردن کاربر را بزنید. در ضمن از بخش حریم خصوصی صفحه تنظیمات می‌توانید، کاربران مسدود شده خود را مدیریت کنید.',
    },
    q8: {
      title:
        'چگونه دانلود خودکار تصاویر، ویدئوها، صوت، آهنگ و فایل را فعال یا غیرفعال نمایم؟',
      description:
        'برای مدیریت و کنترل دانلود خودکار، بعد از ورود به بخش تنظیمات، از زیربخش داده‌ها و ذخیره‌سازی، می‌توانید گزینه دانلود خودکار رسانه‌ها را فعال یا غیرفعال نمایید.',
    },
    q9: {
      title:
        'چگونه می توانم کش مربوط به پلتفرم پنل کاربری آلفا اسکول را خالی کنم؟',
      description:
        'بعد از ورود به بخش تنظیمات؛ از زیربخش داده‌ها و ذخیره‌سازی، روی گزینه پاک کردن حافظه موقت بزنید تا حافظه را حذف و خالی نمایید.',
    },
  },
  premiumFeatures: {
    weblite: `قابلیت‌های ویژه ${APP_NAME}`,
    onlineClass: {
      title: 'کلاس آنلاین',
      sub1: 'قابلیت ضبط ابری',
      sub2: 'قابلیت پخش آفلاین',
    },
    workspace: {
      title: 'فضای اختصاصی برای مجموعه‌ها و مدارس',
      sub1: 'مدیریت راحت‌تر کانال‌ها و گروه‌ها',
      sub2: 'برندینگ بهتر برای مجموعه شما',
    },
    courseVitrine: {
      title: 'فهرست دوره',
      sub1: 'مرتب سازی محتواهای کانال',
      sub2: 'دسترسی راحت‌تر مخاطبین کانال به محتواها',
    },
    submit: 'درخواست خرید',
    callRequestSent: 'درخواست شما ثبت شده است',
  },
  supportModal: {
    description:
      'کاربرگرامی جهت ارتباط با تیم پشتیبانی لطفا از طریق تلگرام با آیدی زیر در ارتباط باشید:',
    confirmText: 'متوجه شدم',
    copy: 'کپی',
  },
  premiumFeatureRequestForm: {
    title: 'درخواست خرید',
    whoAreYou: {
      title: 'کدام گزینه شما را بهتر تعریف می‌کند؟*',
      TEACHER: 'معلم یا برگزارکننده دوره',
      INSTITUTE: 'مجموعه آموزشی یا آموزشگاه',
      SCHOOL: 'مدرسه',
    },
    yourPlan: {
      title: 'کدام یک از موارد زیر در برنامه شما وجود دارد؟*',
      ONLINE_CLASS: 'برگزاری کلاس‌های آنلاین',
      PRIVATE_CLASS: 'برگزاری کلاس‌های خصوصی',
      OFFLINE_CLASS: 'برگزاری دوره آفلاین',
      SCHOOL_ONLINE_CLASS:
        'برگزاری کلاس‌های آنلاین مدارس (ویژه تعطیلی‌های زمستان)',
    },
    askUs: 'اگر موردی وجود دارد که می‌خواهید بیان کنید بفرمایید.',
    description: 'توضیحات',
    submit: 'ارسال درخواست',
  },
  contactUs: {
    address: {
      title: 'آدرس',
      description: 'تهران، ستارخان، باقرخان، گناباد، پلاک ۴۶، واحد ۱۰',
    },
    email: {
      title: 'ایمیل',
      description: 'info@weblite.im',
    },
    phone: {
      title: 'تلفن',
      description: '02166574375',
    },
  },
  myAccountEdit: {
    save: 'ذخیره',
    pleaseSelect: 'لطفاً انتخاب کنید...',
    return: 'بازگشت',
    title: 'ویرایش پروفایل',
    base: 'پایه',
    lesson: 'درس',
    nthBaseLesson: 'درس پایه {{n}}',
    maximumBasesExceeded: 'حداکثر ۴ پایه را می‌توانید انتخاب کنید',
    maximumLessonsExceeded: 'حداکثر ۴ درس را می‌توانید انتخاب کنید',
    selectBase: 'پایه را انتخاب کنید...',
    // selectBase: 'پایه را انتخاب کنید...',
    selectYourMajor: 'رشته خودتان را انتخاب کنید...',
    selectYourCounty: 'استان و شهر خود را انتخاب کنید...',
    selectLesson: 'درس را انتخاب کنید...',
    selectLessonForBase: 'درس پایه موردنظر را انتخاب کنید...',
  },
  selectRole: {
    notSelected: 'مشخص نشده',
    student: 'دانش آموز',
    studentDescription: 'دانش آموز، دانشجو، هنرجو',
    teacher: 'معلم یا برگزارکننده',
    teacherDescription: 'معلم، مشاور، ادمین',
    title: 'کدام یک شما را بیشتر توصیف می‌کند؟',
  },
  settings: {
    title: 'تنظیمات',
    sections: {
      notification: {
        title: 'اعلان‌ها',
        mute: 'بی‌صدا کردن اعلان‌ها',
      },
      privacy: {
        title: 'حریم خصوصی',
        blockedUsers: 'کاربران مسدود شده',
      },
      contacts: {
        sync: 'همگام سازی خودکار مخاطبین',
        repetitiveContacts: 'پیشنهاد مخاطبین پرتکرار',
        deleteSyncContacts: 'حذف مخاطبین همگام سازی شده',
        reloadContacts: 'بارگذاری مجدد مخاطبین',
      },
      storage: {
        title: 'داده‌ها و ذخیره‌سازی',
        clearStorage: 'پاک کردن حافظه‌ی موقت',
        description: 'پاک‌سازی اطلاعات دانلود شده از دستگاه شما',
        autoDownload: 'دانلود خودکار رسانه‌ها',
        autoPlay: 'پخش پیوسته فایل‌های صوتی',
      },
      language: {
        title: 'زبان',
        selectedLanguage: 'زبان انتخاب شده',
        choiceLanguage: 'انتخاب زبان',
        persian: 'فارسی',
        arabic: 'العربیة',
        english: 'انگلیسی',
      },
      security: { title: 'امنیت', activeDevices: 'دستگاه‌های فعال' },
    },
    privacy: {
      questions: {
        phone: 'چه کسی می‌تواند شماره‌ی همراه من را ببیند؟',
        status: 'چه کسی می‌تواند زمان آخرین بازدید شما را ببیند؟',
        link_via_forward:
          'چه کسی می‌تواند در هنگام ارسال پیام‌های من، لینکی به حساب کاربری من اضافه کند؟',
        image: 'چه کسی می‌تواند عکس حساب من را ببیند؟',
        add_hall: 'چه کسی می‌تواند من را عضو گروه‌ها و کانال‌ها کند؟',
      },
      type: {
        phone: 'شماره‌ی همراه',
        status: 'آخرین بازدید و آنلاین بودن',
        link_via_forward: 'ارسال پیام شما به دیگران',
        image: 'عکس حساب شما',
        add_hall: 'پیوستن به گروه‌ها و کانال‌ها',
      },
      policy: {
        exceptions: (include: number, exclude: number) =>
          include || exclude
            ? ` (${exclude ? `${toLocale(exclude)}-` : ''}${
                include && exclude ? ',' : ''
              }${include ? `${toLocale(include)}+` : ''})`
            : '',
        every_body: 'همه',
        no_body: 'هیچ‌کس',
        contacts: 'مخاطبین من',
      },
      exception: {
        exceptionCount: (count: number) => `${toLocale(count)} کاربر`,
        add: 'افزودن استثناها',
        always: 'همیشه اجازه داده شود',
        never: 'هرگز اجازه داده نشود',
        addUsers: 'افزودن کاربران',
        exceptions: 'استثناها',
        set: 'تنظیم استثناها',
      },
    },
    deleteAccount: {
      title: 'حذف حساب کاربری',
      description:
        'برای حذف حساب کاربری ابتدا باید کد تایید ارسال شده به تلفن همراه خود را وارد کنید.',
      confirm: 'ارسال کد تایید',
      verification: {
        title: 'کد تایید را وارد کنید',
        desc: (phone: number) =>
          `کد تایید حذف حساب کاربری به شماره ${phone} ارسال شده است`,
        confirm: 'حذف حساب کاربری',
      },
    },
    logout: 'خروج از حساب کاربری',
  },
  privacyPolicy: {
    title: 'قوانین حریم شخصی',
    description0:
      'رعایت حریم شخصی کاربران برای پنل کاربری آلفا اسکول بسیار حائز اهمیت است. در این متن نحوۀ ذخیره‌سازی و استفادۀ پنل کاربری آلفا اسکول از اطلاعاتی که در نتیجه استفادۀ کاربران از خدمات پنل کاربری آلفا اسکول در سامانۀ پنل کاربری آلفا اسکول ثبت می‌شود شرح داده شده است.',
    title1: 'جمع‌آوری اطلاعات',
    description1:
      'اطلاعاتی که شما مستقیما در پنل کاربری آلفا اسکول ثبت می‌کنید: بخشی از اطلاعاتی که پنل کاربری آلفا اسکول ذخیره می‌کند اطلاعاتی است که شما به صورت مستقیم در فرآیند ثبت نام ثبت می‌کنید. این اطلاعات شامل نام، نام خانوادگی و شماره تلفن همراه می‌باشد.',
    title2: 'نحوه استفاده از خدمات',
    description2:
      'پنل کاربری آلفا اسکول ممکن است اطلاعات مربوط به نحوه استفاده کاربران از نرم‌افزار موبایل و سایت پنل کاربری آلفا اسکول را ثبت می‌کند. از این اطلاعات برای بهبود کیفیت خدمات استفاده می‌شود. اطلاعات مربوط به دستگاه مورد استفاده و شبکه اینترنت: پنل کاربری آلفا اسکول ممکن است اطلاعات مربوط دستگاهی که شما از طریق آن از سامانه استفاده می‌کنید (تلفن همراه، تبلت و غیره) از جمله نوع دستگاه، سیستم عامل، مشخصات سخت افزاری و همچنین اطلاعات مربوط به روش اتصال شما به اینترنت از جمله شبکه 3G، وای‌فای (WiFi) و غیره را ذخیره کند.',
    title3: 'استفاده از اطلاعات',
    description3:
      'اطلاعاتی که در پنل کاربری آلفا اسکول ذخیره می‌شود در موارد زیر ممکن است مورد استفاده قرار بگیرد و استفادۀ کاربر از سرویس پنل کاربری آلفا اسکول به منزلۀ قبول و اعطای اختیار به پنل کاربری آلفا اسکول جهت استفاده و بهره‌برداری از اطلاعات فوق الاشعار به شرح زیر می‌باشد: ارائه، نگهداری و بهبود کیفیت خدمات؛ شخصی‌سازی سرویس برای هر کاربر شامل ارائه پیشنهادهای ویژۀ هر کاربر؛ بدیهی است مسئولیت حفظ و نگهداری از تمامی اطلاعات فوق الاشعار برعهده پنل کاربری آلفا اسکول می باشد؛ به نحوی که هیچ شخص اعم از حقیقی و یا حقوقی غیر ذیصلاح حق دسترسی به اطلاعات مذکور را نخواهد داشت. صرفاً در صورتی که طبق درخواست و یا صدور دستور مقتضی از سوی مراجع قضایی، اطلاعات کاربر – اعم از اینکه به صورت مستقیم از سوی ایشان و یا به صورت خودکار جمع آوری و ضبط شده باشد – مطالبه شود، پنل کاربری آلفا اسکول موظف به ارایۀ اطلاعات درخواستی به مراجع مذکور خواهد بود.',
  },
  contacts: {
    add: 'افزودن مخاطب',
    phonePlaceholder: '۰۹xx xxx xxxx',
    editContact: 'ویرایش مخاطب',
    newContact: 'مخاطب جدید',
  },
  signin: {
    enterPhone: 'جهت ورود شماره همراه خود را وارد کنید',
    confirm: 'ادامه',
    checkboxOption: 'همگام سازی خودکار مخاطبین',
    throttle: {
      phone:
        'به‌دلیل درخواست‌های متعدد برای دریافت کد ورود با این شماره، ارسال کد موقتاً محدود شده است. لطفاً تا {{x}} دیگر دوباره تلاش کنید.',
      general:
        'به‌دلیل درخواست‌های متعدد برای ورود، امکان تلاش مجدد موقتاً محدود شده است. لطفاً تا {{x}} دیگر دوباره تلاش کنید.',
    },
    verification: {
      edit: 'اصلاح',
      resendCode: 'ارسال مجدد کد تایید',
      resendFailed: 'ارسال مجدد ناموفق بود. لطفاً کمی صبر کنید.',
      tooManyResends:
        'تعداد درخواست‌ها زیاد شد. تا {{x}} دیگر دوباره تلاش کنید.',
      validTillXMore: 'معتبر تا {{x}} دیگر',
      enterCode: 'کد ۵ رقمی ارسالی را وارد کنید:',
      wrongCodeEntered: 'کد وارد شده اشتباه است',
      maxTriesReached: 'حداکثر دفعات تلاش انجام شد. لطفاً از اول تلاش کنید',
      signupClosed: 'ثبت نام بسته شده است',
      inputPlaceholder: 'کد تایید ۵ رقمی...',
      description: 'کد فعال سازی به شماره شما ارسال شده است',
      syncDeviceCode: () =>
        boldSome(
          'کد تایید به دستگاه متصلتان به ',
          '«پنل کاربری آلفا اسکول»',
          'ارسال شد لطفا آن را وارد کنید.',
        ),
    },
    serverCodes: {
      INVALID_PHONE: 'شماره تلفن وارد شده صحیح نیست، دوباره تلاش کنید.',
      FAILED_DELIVERY:
        'سامانه پیامکی‌مون بد قولی کرده، لطفاً دوباره امتحان کنید.',
      BANNED: 'شما مجاز به ورود نیستید',
      NOT_INVITED: 'شما هنوز دعوت نشده‌اید',
      NOT_IN_WHITELIST: 'شما مجوز ورود به سامانه را ندارید.',
      TOO_MANY_REQUESTS:
        'تعداد درخواست‌ها زیاد است. لطفاً کمی بعد دوباره تلاش کنید.',
    },
  },
  addAdmin: {
    title: 'افزودن مدیر',
  },
  memberList: {
    title: 'لیست اعضا',
  },
  addMembers: {
    title: 'افزودن اعضا',
    joinedAt: {
      prefix: 'در تاریخ',
      postfix: 'پیوست',
    },
  },
  removeMembers: {
    title: 'حذف اعضا',
  },
  multiSelectUserList: {
    noUserSelected: 'کاربری انتخاب نشده‌است',
  },
  admins: {
    title: 'مدیران',
    addAdmin: 'افزودن مدیر',
    promotedBy: 'ارتقا یافته توسط',
    questionSupport: 'مسئول رفع اشکال',
  },
  signup: {
    title: 'اطلاعات خود را وارد کنید',
    withSigningUp: 'با ورود به پنل کاربری آلفا اسکول ',
    haveReadAndAccept: ' آن را می‌پذیرید.',
    emptyName: 'نام نباید خالی باشد',
    referrerCode: (optional: boolean) =>
      `کد معرف را وارد کنید (${optional ? 'اختیاری' : 'اجباری'})`,
    insertReferrerCode: 'کد معرف خود را وارد کنید',
    linkOrIdentifier: 'لینک یا آیدی کلاس',
    joiningInHall: 'در حال عضویت در کلاس',
    selectOrganizerType: {
      title: 'کدام گزینه شما را بهتر تشریح می‌کند؟',
      options: {
        person: {
          title: 'فرد',
          description: 'معلم، مشاور، دبیر، استاد و…',
        },
        academy: {
          title: 'مجموعه آموزشی',
          description: 'ادمین مجموعه، دبیر مجموعه، مدیر مجموعه و…',
        },
        school: {
          title: 'مدرسه',
          description: 'مدیر مدرسه، معاون مدرسه، معلم مدرسه و…',
        },
      },
    },
  },
  phoneInput: {
    errorMessage: 'وارد کردن این ورودی الزامی است',
  },
  linkInput: {
    infoMessage: 'در حال بررسی نام...',
    errorMessage: 'این نام نامعتبر است',
    successMessage: 'این نام معتبر است',
  },
  loadingModal: {
    messages: 'در حال بارگیری پیام‌ها...',
    saveChanges: 'در حال ثبت تغییرات...',
    loadFromServer: 'در حال دریافت اطلاعات از سرور...',
    processingMessage: 'در حال پردازش پیام...',
    sharedMedia: 'در حال بارگیری محتواها...',
    wappOverlay: 'در حال اجرای وپ...',
  },
  changelogModal: {
    title: 'تغییرات نسخه جدید',
    version: 'نسخه',
    features: 'قابلیت‌های جدید',
    improvements: 'بهبود‌ها',
    bugs: 'رفع باگ‌ها',
  },
  verificationCodeInput: {
    errorMessage: 'کد وارد شده اشتباه است',
  },
  editUsername: {
    descriptionBox: `نام باید حداقل ۵ کاراکتر باشد و باید با حرف انگلیسی شروع شود.\nمی‌تواند شامل حروف و اعداد انگلیسی و '_' باشد.`,
  },
  editBio: {
    descriptionBox:
      'این متن در پروفایل شما نمایش داده می‌شود. شما می‌توانید چند خط در مورد خودتان بنویسید.',
  },
  hallRestrictedModal: {
    title: hallType => `محدودیت دسترسی به ${hallType}`,
    description:
      'برای دسترسی به کانال ابتدا باید قسط عقب مانده خود را پرداخت کنید.',
    buttonText: 'بازگشت',
  },
  hallPermissionsPage: {
    common: {
      pinMessages: 'سنجاق کردن پیام‌ها',
      sendWapp: 'ارسال ابزار',
    },
    channelAdminRights: {
      title: 'اختیارات مدیر',
      subTitle: 'این مدیر چه کارهایی می‌تواند انجام دهد؟',
      actionButtonText: 'برکناری مدیر',
      secondaryButtonText: 'انتقال مالکیت کانال',
      changeHallInfo: 'تغییر اطلاعات کانال',
      editMessage: 'ویرایش پیام‌ها',
      deleteMessages: 'حذف پیام‌های دیگران',
      questionSupport: 'دسترسی به رفع اشکال',
    },
    groupMemberPermissionsOverride: {
      title: 'اختیارات کاربر',
      subTitle: 'این کاربر چه کارهایی می‌تواند انجام دهد؟',
      actionButtonText: 'حذف از گروه',
      sendMessage: 'ارسال پیام متنی',
    },
    groupMemberPermissions: {
      title: 'اختیارات اعضا',
      subTitle: 'اعضای گروه چه کارهایی می‌توانند انجام دهند؟',
      actionButtonText: 'مشاهده و تنظیم استثناها',
      addMembers: 'افزودن اعضای جدید',
      changeHallInfo: 'تغییر اطلاعات گروه',
      sendMessage: 'ارسال پیام متنی',
      sendMedia: 'ارسال چندرسانه‌ای',
    },
    groupAdminRights: {
      title: 'اختیارات مدیر',
      subTitle: 'این مدیر چه کارهایی می‌تواند انجام دهد؟',
      actionButtonText: 'برکناری مدیر',
      secondaryButtonText: 'انتقال مالکیت گروه',
      addNewAdmins: 'افزودن مدیران جدید',
      banUsers: 'محروم کردن کاربران',
      changeHallInfo: 'تغییر اطلاعات گروه',
      deleteMessages: 'پاک کردن پیام‌ها',
      inviteViaLink: 'دعوت به وسیله لینک دعوت',
    },
  },
  channel: {
    teacherTestChannelName: fullName => `دوره آنلاین استاد ${fullName}`,
  },
  hallSetting: {
    group: 'تنظیمات گروه',
    channel: 'تنظیمات کانال',
  },
  hallAdvancedSettings: {
    title: 'قابلیت‌های پیشرفته',
    courseVitrine:
      'ابزار نظم دهی و دسته بندی به محتواهای کانال به منظور ایجاد دسترسی بهتر',
    issue:
      'ابزار ارتباطی مخاطبین با ادمین کانال. سوالات کاربران را دریافت کنید و یا از آن‌ها سوال بپرسید.',
    forwardRestriction: {
      title: 'محدود کردن ارسال به دیگران',
      description: 'جلوگیری از ارسال محتواهای کانال به چت‌های دیگر',
    },
    watermark: {
      title: 'واترمارک متنی (شماره موبایل)',
      description: 'نمایش شماره تلفن کاربر بر روی کلاس آنلاین',
    },
    vodActivation: {
      title: 'بارگزاری ویدئو با حجم بالا',
      description:
        'بارگذاری بالای ۳۰ مگ، قفل‌گذاری و محافظت از ویدیو، امکان تنظیم کیفیت و قابلیت‌های دیگر',
    },
    userSessionsLimit: {
      title: 'محدود کردن تعداد نشست کاربران',
      description: 'محدود کردن تعداد دستگاه‌هایی که به کانال دسترسی دارند.',
    },
    hideMemberCount: {
      title: 'پنهان کردن تعداد مشترکین کانال',
      description:
        'با فعال کردن این قابلیت، کاربران کانال شما تعداد مشترکینتان را نمی‌بینند.',
    },
  },
  createCourseTourStartDialog: {
    title: 'آموزش نحوه ایجاد دوره',
    description:
      'برای شروع ساخت دوره، کافیه نقاط نارنجی رنگ رو دنبال کنی تا قدم‌به‌قدم راهنمایی‌ات کنیم.',
    submit: 'ادامه',
    cancel: 'لغو',
  },
  hallAccessibility: {
    linkPlaceHolder: 'نام لینک',
  },
  newChatModal: {
    newChat: 'گفت‌وگوی جدید',
    createChannel: 'ایجاد کانال (ایجاد دوره)',
    createChannelDescription: 'برگزاری کلاس آنلاین، دوره ویدئویی و آزمون تستی',
    createGroup: 'ایجاد گروه',
    createGroupDescription: 'به منظور رفع اشکال و صحبت گروهی',
    myContacts: 'مخاطبین من',
    createWorkspace: 'ایجاد فضای اختصاصی',
    createWorkspaceDescription:
      'به منظور برندسازی و مدیریت تعداد زیاد کانال و گروه',
  },
  forceUpdateWeb: {
    title: 'بروزرسانی فوری',
    description:
      'نسخه فعلی دیگر پشتیبانی نمی‌گردد. برای جلوگیری از بروز مشکلات احتمالی، لطفا وارد نسخه جدید شوید.',
    actionButton: 'ورود به نسخه جدید',
    receivingUpdate: 'در حال دریافت نسخه جدید',
    updateReceived: 'بروزرسانی دریافت شد',
  },
  sendInviteLink: {
    title: 'ارسال لینک دعوت',
    description: (isGroup: boolean) =>
      `برخی مخاطبین، دسترسی عضویت در ${
        isGroup ? 'گروه' : 'کانال'
      } را محدود کرده‌اند. در عوض شما می‌توانید برایشان لینک دعوت ارسال کنید.`,
    shouldUnban: (count: number) =>
      `${count} نفر از افراد مسدود شده‌اند. برای عضویت آن‌ها باید ابتدا مدیر آن‌ها را رفع مسدودیت کند.`,
    inviteText: (sender: string, isGroup: boolean, inviteLink: string) =>
      `${sender} شما را برای پیوستن به ${
        isGroup ? 'گروه' : 'کانال'
      } زیر دعوت کرده است\n ${inviteLink}`,
  },
  inviteLinks: {
    common: {
      inviteLink: 'لینک دعوت',
      expiredLink: 'لینک منقضی شده',
      oneHour: '۱ ساعت',
      oneDay: '۱ روز',
      oneWeek: '۱ هفته',
      unlimited: 'نامحدود',
      today: 'امروز',
      createLink: 'ایجاد لینک',
      editLink: 'ویرایش لینک',
    },
    modal: {
      linkIsCreatedBy: 'ایجاد شده توسط',
      joinedUser: 'مشاهده‌ی افرادی که از طریق لینک عضو شدند',
    },
    create: {
      needsApproval: {
        title: 'تائید اعضای جدید',
        desc: 'کاربران جدید نمی‌توانند بدون تایید ادمین به کانال بپیوندند.',
      },
      timeLimit: {
        subheader: 'محدود کردن بر اساس مدت زمان',
        description:
          'شما می‌توانید مشخص کنید که لینک پس از مدت زمان مشخصی منقضی شود.',
        inputPlaceholder: 'مدت زمان دلخواه را تنظیم کنید...',
      },
      usageLimit: {
        subheader: 'محدود کردن بر اساس تعداد استفاده',
        description:
          'شما می‌توانید مشخص کنید که لینک پس از دفعات استفاده‌ی مشخصی منقضی شود.',
        inputPlaceholder: 'تعداد استفاده‌ی دلخواه را تنظیم کنید...',
      },
    },
    list: {
      createNewLink: 'ایجاد لینک جدید',
      revoked: 'باطل شده',
      isExpired: 'منقضی شده‌است',
      limitReached: 'به سقف مجاز رسیده‌است',
      dayIsRemaining: 'روز باقی مانده‌است',
      lessThanOneDayIsRemaining: 'کمتر از یک روز باقی مانده است',
      noOneHasJoined: 'هیچ‌کس نپیوست',
      noOneHasJoinedYet: 'هنوز کسی نپیوسته‌است',
      oneJoined: 'نفر پیوستند',
      oneCanJoin: 'نفر می‌توانند بپیوندند',
      inviteLinks: 'لینک‌های دعوت',
      createdLinks: 'لینک‌های ایجاد شده',
      revokedLinks: 'لینک‌های باطل شده',
      deleteAllRevokedLinks: 'حذف تمامی لینک‌های باطل شده',
      noLink: 'لینکی وجود ندارد',
    },
  },
  chatList: {
    promoteToPremium: 'ارتقا به نسخه ویژه',
    timeToEndPremiumDemo: time => `${time} تا پایان نسخه رایگان`,
    privateSpace: 'پیام‌های ذخیره شده',
    draft: 'پیش‌نویس:',
    tooManyUnseen: '۹۹+',
    menu: {
      pin: 'سنجاق کردن',
      unPin: 'برداشتن سنجاق',
      addHallToWorkspace: 'افزودن به فضای اختصاصی',
      removeHallFromWorkspace: 'انتقال به چت لیست عمومی',
    },
    tabs: {
      channel: 'کانال‌ها',
      group: 'گروه‌ها',
      pv: 'شخصی',
      all: 'همه',
      wappRoom: 'ابزارها',
      workspaces: 'فضای اختصاصی',
    },
    createCourseOnboardingBar: {
      title: 'میخوای دوره بسازی؟',
    },
  },
  userSessionsLimit: {
    title: 'تعداد دستگاه‌های مجاز',
    description: 'حداکثر دستگاه‌ مجاز کاربران برای مشاهده محتوا',

    one: 'یک دستگاه',
    two: 'دو دستگاه',
    three: 'سه دستگاه',
    unlimited: 'نامحدود',
  },
  userActiveSessionsLimitModal: {
    title: 'محدودیت دستگاه در این کانال',

    registerDescription: (limit: number) =>
      `این کانال فقط روی ${limit} دستگاه قابل استفاده است. این دستگاه را بین دستگاه‌هایی که اجازه دسترسی دارند ثبت نکرده‌اید.`,
    notAllowedDescription: (limit: number) =>
      `برای ورود به این کانال لازم است از دستگاه‌های اضافی خود خارج شوید. ورود به این کانال تنها از طریق ${limit} دستگاه امکان پذیر است.`,

    allowedDevices: 'دیگر دستگاه‌های دارای مجوز',
    terminateSession: 'غیر فعال کردن',
    register: 'ثبت این دستگاه',
    showMore: (count: number) => `نمایش ${count} دستگاه دیگر`,
  },
  sharedMedia: {
    media: 'رسانه',
    link: 'لینک',
    voice: 'صوت',
    audio: 'موسیقی',
    file: 'فایل',
  },
  chatAppBar: {
    title: 'گفت‌و‌گو',
  },
  createHall: {
    createChannel: 'ایجاد کانال',
    createGroup: 'ایجاد گروه',
    createInWorkspace:
      'این کانال فقط از داخل فضای اختصاصی شما در دسترس خواهد بود و در گفتگو‌های عمومی نمایش داده نمی‌شود. پس از ایجاد کانال قابلیت جا‌به‌جایی وجود دارد.',
  },
  selectWorkspaceName: {
    title: 'ایجاد فضای اختصاصی',
    edit: 'ویرایش فضای اختصاصی',
    name: 'نام فضای اختصاصی',
    placeholder: 'نام فضای اختصاصی را وارد کنید',
    confirm: 'مرحله بعد',
  },
  selectWorkspaceColor: {
    back: 'مرحله قبل',
    confirm: 'ایجاد',
  },
  selectWorkspace: {
    title: 'فضای اختصاصی مورد نظر را انتخاب کنید',
  },

  forwardAppBar: {
    title: 'ارسال به...',
    receiver: (num: number) => `${toLocale(num)} دریافت کننده`,
  },
  chatListSearch: {
    globals: 'جستجوهای سراسری',
    recent: 'جستجو‌های اخیر',
    deleteAll: 'حذف همه',
  },
  emptyChatList: {
    title: 'گفت‌وگو‌های شما در اینجا نمایش داده می‌شود',
    description:
      'با زدن دکمه زیر یا از طریق جست‌و‌جو به وسیله دکمه‌ی بالای صفحه گفت‌و‌گو را شروع کنید',
  },
  joinHallDialog: {
    joinChannel: 'پیوستن به کانال',
    joinGroup: 'پیوستن به گروه',
  },
  installTWADialog: {
    title: 'به پنل کاربری آلفا اسکول خوش آمدید!',
    description:
      'برای استفاده از پنل کاربری آلفا اسکول لطفا نسخه اپلیکیشن را نصب کنید',
    updateTitle: 'بروزرسانی جدید!',
    updateDescription:
      'نسخه جدید را می‌توانید از یکی از فروشگاه‌های زیر دریافت کنید',
  },
  featureOnboadringDialog: {
    classroom: {
      title: 'یادگیری تعاملی و مؤثر با',
      name: 'کلاس آنلاین',
      description: 'کلاس آنلاین با امکان',
      listItems: {
        item0: 'برگزاری جلسات زنده آموزشی یا گروهی',
        item1: 'حضور و مشارکت به صورت همزمان ',
        item2: 'استفاده از ابزارهایی مانند اشتراک صفحه و چت',
      },
    },
    poll: {
      title: 'تصمیم‌گیری بهتر با',
      name: 'نظرسنجی',
      description: 'نظرسنجی با امکان',
      listItems: {
        item0: 'طراحی پرسش‌های کوتاه چندگزینه‌ای',
        item1: 'جمع‌آوری دیدگاه‌ها و ترجیحات کاربران',
        item2: 'دریافت بازخورد سریع',
      },
    },
    takTest: {
      title: 'تمرین سریع و سنجش لحظه‌ای با',
      name: 'تک تست',
      description: 'تک تست با امکان',
      listItems: {
        item0: 'ایجاد یک سوال یا تست منفرد',
        item1: 'استفاده برای مرور سریع یا ارزیابی کوتاه',
        item2: 'مشاهده و تحلیل فوری نتایج',
      },
    },
    homeWork: {
      title: 'بهبود یادگیری و پیگیری پیشرفت با',
      name: 'تکلیف',
      description: 'تکلیف با امکان',
      listItems: {
        item0: 'تعیین وظایف و تمرین‌های مشخص',
        item1: 'ارسال تکالیف توسط کاربران',
        item2: 'بررسی و ارائه بازخورد',
      },
    },
    descriptiveExam: {
      title: 'سنجش کیفی‌تر با',
      name: 'آزمون تشریحی',
      description: 'آزمون تشریحی با امکان',
      listItems: {
        item0: 'طراحی سوالات باز و تشریحی',
        item1: 'ارزیابی فهم عمیق‌تر و مهارت‌های تحلیلی کاربران',
        item2: 'بررسی دقیق پاسخ‌ها',
      },
    },
    post: {
      title: 'تعامل بهتر با',
      name: 'کلاس ویدیوئی',
      description: 'کلاس ویدیوئی با امکان',
      listItems: {
        item0: 'انتشار محتوای متنی، تصویری و ویدیویی',
        item1: 'انتقال اطلاعات، اخبار و آموزش‌ها',
        item2: 'برقراری ارتباط مؤثر و سازمان‌یافته با کاربران',
      },
    },
    testExam: {
      title: 'ارزیابی سریع و دقیق با',
      name: 'آزمون تستی',
      description: 'آزمون تستی با امکان',
      listItems: {
        item0: 'طراحی سوالات چندگزینه‌ای',
        item1: 'سنجش دانش و مهارت کاربران',
        item2: 'بررسی و گزارش‌گیری خودکار نتایج',
      },
    },
    createHall: {
      title: 'ارتباط و مدیریت آسان‌تر با',
      name: 'ایجاد کانال یا گروه',
      description: 'ایجاد کانال یا گروه جدید با امکان',
      listItems: {
        item0: 'افزودن اعضای دلخواه',
        item1: 'سازمان‌دهی مکالمات، کلاس‌ها و محتوای اختصاصی',
        item2: 'مدیریت دسترسی‌ها و مشارکت اعضا',
      },
    },
    channelSettings: {
      title: 'کنترل کامل کانال با',
      name: 'تنظیمات کانال',
      description:
        'مدیریت مشخصات اصلی و قابلیت‌های پیشرفته کانال، شامل ابزارهای',
      listItems: {
        item0: 'نظم دهی محتوا',
        item1: 'امکانات ارتباطی',
        item2: 'محدودسازی انتشار',
        item3: 'تنظیمات بارگزاری ویدئو',
        item4: 'قابلیت‌های امنیتی',
      },
    },
    channelProfile: {
      title: 'سازماندهی بهتر و استفاده حرفه‌ای با',
      name: 'پروفایل کانال',
      description: 'مدیریت کانال با امکان کنترل تنظیمات اصلی، شامل',
      listItems: {
        item0: 'مدیریت اعضا',
        item1: 'تعیین دسترسی مدیران',
        item2: 'نظارت بر فعالیت‌ها و محتوای منتشرشده',
      },
    },
    testChannel: {
      title: 'آشنایی آسان با امکانات برنامه با',
      name: 'کانال آزمایشی',
      description:
        'کانال آزمایشی به صورت خودکار برای هر کاربر ایجاد می‌شود و شامل قابلیت‌های',
      listItems: {
        item0: 'کلاس آنلاین',
        item1: 'آزمون تستی',
        item2: 'انتشار پست',
        item3: 'درسنامه',
      },
    },
  },
  emptyState: {
    noUserFound: 'کاربری یافت نشد',
    noContactFound: 'شما هنوز مخاطبی در پنل کاربری آلفا اسکول ندارید...',
    noResultFound: 'نتیجه‌ای یافت نشد',
    noContentFound: 'محتوایی یافت نشد',
    searchHint: 'برای جست‌و‌جوی بهتر، در وارد کردن کلمات دقت کنید',
    noMessages: 'هنوز پیامی در اینجا نیست...',
  },
  errorState: {
    default: 'در دریافت اطلاعات مشکلی بوجود امده است',
  },
  installTwa: {
    recommend: {
      title: 'دریافت اپلیکیشن پنل کاربری آلفا اسکول',
      description:
        'برای استفاده بهتر از پلتفرم پنل کاربری آلفا اسکول، لطفا نسخه اندروید را نصب بفرمایید.',
    },
    force: {
      title: 'دریافت اپلیکیشن پنل کاربری آلفا اسکول',
      description:
        'برای استفاده بهتر از پلتفرم پنل کاربری آلفا اسکول، باید نسخه اندروید را نصب بفرمایید.',
    },
  },
  datePickerModal: {
    inviteLinkExpireDate: {
      title: 'انتخاب زمان',
    },
    birthdate: {
      title: 'انتخاب تاریخ تولد',
    },
  },

  confirmDialog: {
    addHallToWorkspace: {
      title: 'افزودن به فضای اختصاصی',
      description: (count: number, workspaceName: string) =>
        `آیا از افزودن این  ${toLocale(count)} مورد به فضای اختصاصی «${workspaceName}» اطمینان دارید؟`,
      confirmOption: 'افزودن',
      cancelOption: 'لغو',
    },
    removeHallFromWorkspace: {
      title: 'انتقال به چت لیست عمومی',
      description: (count: number) =>
        `آیا از انتقال این  ${toLocale(count)} مورد به چت لیست عمومی اطمینان دارید؟`,
      confirmOption: 'انتقال',
    },
    changeWatermarkSettings: {
      title: 'تغییر تنظیمات واترمارک',
      description:
        'برای اعمال این تغییر نیاز است کلاس خود را بسته و دوباره باز کنید.',
      confirmOption: 'تایید',
    },
    deleteWorkspace: {
      title: 'حذف فضای اختصاصی',
      description: 'آیا از حذف فضای اختصاصی اطمینان دارید؟',
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    reloadContacts: {
      description: 'آیا از بارگذاری مجدد مخاطبین اطمینان دارید؟',
    },
    deleteSyncedContacts: {
      description: () =>
        boldSome(
          'با این کار مخاطبین شما از سرور های پنل کاربری آلفا اسکول حذف خواهد شد . در صورتی که «',
          'همگام سازی مخاطبین',
          '» فعال باشد، دفترچه تلفن فعلی شما مجدداً همگام سازی خواهد شد.',
        ),
    },
    premiumFeatures: {
      description: n =>
        `آیا از فعال کردن ${toLocale(n)} روزه نسخه ویژه رایگان اطمینان دارید؟`,
      title: n => `${toLocale(n)} روز نسخه ویژه رایگان`,
      confirmOption: n => `شروع ${toLocale(n)} روز رایگان`,
    },
    changeChannelType: {
      title: 'تغییر نوع کانال آموزشی',
      description: 'آیا از تغییر نوع کانال آموزشی اطمینان دارید؟',
    },
    callInIos: {
      description:
        'قابلیت تماس در سیستم عامل ios پشتیبانی نمی‌شود. لطفا برای استفاده از این قابلیت، از سیستم‌عامل‌های دیگر استفاده نمایید.',
    },
    banUser: {
      description: {
        prefix: 'آیا از حذف',
        postfix: 'اطمینان دارید؟',
      },
      title: 'حذف کاربر',
      cancelOption: 'لغو',
      confirmOption: 'حذف کاربر',
    },
    discardChanges: {
      title: 'تغییرات اعمال شود؟',
      description: 'شما برخی از تنظیمات را تغییر داده‌اید. تغییرات اعمال شود؟',
      confirmOption: 'اعمال',
      cancelOption: 'خیر',
    },
    profile: {
      description:
        'شما برخی از اطلاعات را تغییر داده‌اید. تغییرات جدید اعمال شود؟',
      confirmOption: 'اعمال تغییرات',
    },
    deleteScheduledCall: {
      title: type => `حذف زمان‌بندی ${type}`,
      description: type => `آیا از حذف زمان‌بندی این ${type} اطمینان دارید؟`,
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    startScheduledCall: {
      title: type => `شروع ${type}`,
      description: type => `آیا از شروع همین الان ${type} اطمینان دارید؟`,
      confirmOption: 'شروع همین الان',
      cancelOption: 'لغو',
    },
    deleteStory: {
      title: 'حذف اطلاع رسانی',
      description: 'آیا از حذف این اطلاع رسانی اطمینان دارید؟',
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    addMember: {
      newMembersGreaterThan3: (text: string) => `${text} عضو`,
      title: (count: string) => `افزودن ${count}عضو`,
      confirmOption: 'افزودن عضو',
      cancelOption: 'لغو',
      description: {
        prefix: 'آیا از افزودن',
        postfix: {
          prefix: 'به',
          postfix: 'اطمینان دارید؟',
        },
      },
    },
    deleteChat: {
      title: (count: number) => `حذف ${toLocale(count)} گفت‌و‌گو`,
      description: 'آیا از حذف این گفت‌و‌گوها اطمینان دارید؟',
      confirmOption: 'حذف گفت‌وگوها',
    },
    deletePv: {
      title: 'حذف گفت‌و‌گو',
      confirmOption: 'حذف گفت‌وگو',
      cancelOption: 'لغو',
      description: {
        prefix: 'آیا از حذف گفت‌و‌گوی',
        postfix: 'اطمینان دارید؟',
      },
      checkboxOption: 'تاریخچه‌ برای شما پاک شود',
    },
    clearPVHistory: {
      title: 'پاک کردن تاریخچه',
      cancelOption: 'لغو',
      confirmOption: 'حذف',
      description: {
        prefix: 'آیا از پاک کردن تاریخچه‌ی گفت‌و‌گوی خود با',
        postfix: 'اطمینان دارید؟',
      },
      moreThan3: (text: string) => `${text} گفت‌گو`,
    },
    clearSearchHistory: {
      title: 'پاک کردن تاریخچه‌ی جست‌وجو',
      cancelOption: 'لغو',
      confirmOption: 'حذف',
      description: 'آیا از پاک کردن تاریخچه‌ی جست‌وجو اطمینان دارید؟',
    },
    deleteMessage: {
      description: {
        oneMessage: (text: string) =>
          `آیا از حذف پیام ${text || ''}اطمینان دارید؟`,
        manyMessage: (text: string) =>
          `آیا از حذف پیام‌های انتخاب شده ${text}اطمینان دارید؟`,
        forGroup: 'برای خود و اعضای گروه ',
        forPv: (name: string) => `برای خود و ${name} `,
      },
      title: {
        oneMessage: 'حذف پیام',
        manyMessage: (text: string) => `حذف ${text} پیام`,
      },
      cancelOption: 'لغو',
      confirmOption: 'حذف',
    },
    deleteContact: {
      description: 'آیا از حذف این مخاطب اطمینان دارید؟',
      title: 'حذف مخاطب',
      cancelOption: 'لغو',
      confirmOption: 'حذف',
    },
    leaveHall: {
      description: {
        prefix: 'آیا از ترک',
        postfix: 'اطمینان دارید؟',
      },
      title: (text: string) => `ترک ${text}`,
      cancelOption: 'لغو',
      confirmOption: (text: string) => `ترک ${text}`,
    },
    openLink: {
      title: 'آیا این لینک باز شود؟',
    },
    pushNotification: {
      description:
        'برای مطلع شدن از پیام‌هایی که براتون ارسال میشه اعلان رو فعال کنید.',
      title: 'فعال سازی اعلان',
    },
    discardVoiceMessage: {
      title: 'حذف پیام صوتی',
      description: 'آیا میخواهید پیام صوتی خود را حذف کنید؟',
    },
    restartRecordingVoice: {
      title: 'شروع مجدد ضبط',
      description: 'آیا میخواهید صدای ضبط شده خود را حذف و دوباره ضبط کنید؟',
    },
    discardRecordingVoice: {
      title: 'حذف پیام صوتی',
      description:
        'آیا از متوقف کردن ضبط صدا و حذف پیام صوتی خود اطمینان دارید؟',
    },
    logout: {
      description: 'آیا از پایان دادن به این نشست اطمینان دارید؟',
      title: 'پایان دادن به نشست',
      cancelOption: 'لغو',
      confirmOption: 'پایان دادن',
    },
    terminateSessions: {
      description: 'آیا از پایان دادن به باقی نشست‌ها اطمینان دارید؟',
      title: 'پایان دادن به نشست‌ها',
      cancelOption: 'لغو',
      confirmOption: 'پایان دادن',
    },
    deleteAccount: {
      description:
        'با حذف حساب کاربری تمامی گفتگو‌ها و مخاطبین شما برای همیشه حذف خواهد شد و غیرقابل بازیابی خواهد بود. آیا از این کار اطمینان دارید؟',
      title: 'حذف حساب کاربری',
      confirmOption: 'ادامه فرایند حذف حساب',
    },
    deleteHall: {
      description: (text: string) => `آیا از حذف و ترک ${text} اطمینان دارید؟`,
      checkboxOption: (text: string) => `حذف ${text} برای تمامی اعضا`,
      title: (text: string) => `حذف ${text}`,
      cancelOption: 'لغو',
      confirmOption: (text: string) => `حذف ${text}`,
    },
    clearDb: {
      description: 'آیا از پاک کردن حافظه موقت مطمئن هستید؟',
      title: 'پاک کردن حافظه موقت',
    },
    invite: {
      title: 'تایید دعوت',
      description: (phone: string) =>
        boldSome(
          'آیا از دعوت فردی با شماره موبایل',
          toLocale(phone),
          'مطمئن هستید؟',
        ),
      descriptions: (count: number) =>
        boldSome(
          'آیا از دعوت',
          toLocale(count),
          'نفر به این پلتفرم مطمئن هستید؟',
        ),
    },
    deleteContent: {
      description: 'آیا از حذف محتوای انتخاب شده اطمینان دارید ؟',
    },
    deleteContentFromInline: {
      checkboxOption: 'حذف محتوای انتخاب شده از ویترین دوره',
    },
    pinMessage: {
      title: 'سنجاق کردن پیام',
      description: 'آیا می‌خواهید این پیام را به بالای گفتگو سنجاق کنید؟',
      pinForUser: (name: string) => boldSome('برای ', name, ' نیز سنجاق شود'),
      sendNotif: (isGroup: boolean) =>
        `برای اعضا ${isGroup ? 'گروه' : 'کانال'} اعلان ارسال شود`,
    },
    replacePinMessage: {
      title:
        'آیا مطمئن هستید که می‌خواهید پیام جدیدی را به جای پیام قبلی سنجاق کنید؟',
    },
    unPinMessage: {
      title: 'برداشتن سنجاق',
      description: 'آیا از برداشتن سنجاق این پیام برای همه اطمینان دارید؟',
    },
    promoteToOwner: {
      title: 'انتقال مالکیت',
      description: (name: string) =>
        `آیا از انتقال مالکیت این کانال به ${name} اطمینان دارید؟`,
    },
    endOngoingCall: {
      callTypes: {
        call: 'تماس با',
        group_call: 'جلسه با',
        live: 'پخش زنده',
        tribune: 'تریبون',
        classroom: 'کلاس',
      },
      title: 'گفتگوی صوتی دیگری در جریان است',
      description: (ongoingCallDesc: string, newCallDesc: string) =>
        `آیا ${ongoingCallDesc} پایان یابد و ${newCallDesc} شروع شود؟`,
      confirmOption: 'بله',
    },
    disableRecentUsers: {
      title: 'غیر فعال کردن پیشنهاد‌ها',
      description:
        'این کار، اطلاعات مربوط به افرادی که مکررا برای آن‌ها پیام ارسال می‌کنید را در قسمت جستجو گفتگو حذف خواهد کرد.',
    },
  },
  selectMenu: {
    loading: 'در حال دریافت اطلاعات',
    nothingFound: 'موردی یافت نشد',

    county: {
      selectProvince: 'انتخاب استان',
      selectCounty: 'انتخاب شهر',
    },
    gender: {
      selectGender: 'انتخاب جنسیت',
    },
  },
  message: {
    VOICE: 'پیام صوتی',
    VIDEO: 'ویدیو',
    WAPP: 'وپ',
    FILE: 'فایل',
    IMAGE: 'عکس',
    AUDIO: 'فایل صوتی',
    CONTACT: 'مخاطب',
    tool: 'ابزار',
    forwardedFrom: 'ارسال شده از',
    repliedTo: 'در پاسخ به',
    edited: 'ویرایش شده',
    unreadMessages: 'پیام‌های خوانده نشده',
    deleted: 'پیام حذف شده',
    onboarding: {
      group: {
        title: (groupName: string) => `به گروه «${groupName}» خوش آمدید!`,
        actions: {
          addMember: 'افزودن عضو',
          addDescription: 'اضافه کردن توضیحات به گروه',
          shareInviteLink: 'اشتراک گذاری لینک دعوت با مخاطبینتان',
        },
        actionButtons: {
          addMember: 'افزودن اعضا',
          addDescription: 'اضافه کردن توضیحات',
          shareInviteLink: 'اشتراک گذاری لینک دعوت',
        },
        description: (actions: string[]) => {
          const actionsStr = actions.reduce((prev, current, i, arr) => {
            const or = 'یا'
            const comma = '،'
            if (!prev) return current
            if (i === arr.length - 1) return `${prev} ${or} ${current}`
            return `${prev}${comma} ${current}`
          }, '')

          return `با ${actionsStr} شروع کنید!`
        },
      },
      channel: {
        title: (channelName: string) => `به کانال «${channelName}» خوش آمدید!`,
        actions: {
          addMember: 'افزودن عضو',
          addDescription: 'اضافه کردن توضیحات به کانال',
          shareInviteLink: 'اشتراک گذاری لینک دعوت با مخاطبینتان',
        },
        actionButtons: {
          addMember: 'افزودن اعضا',
          addDescription: 'اضافه کردن توضیحات',
          shareInviteLink: 'اشتراک گذاری لینک دعوت',
        },
        description: (actions: string[]) => {
          const actionsStr = actions.reduce((prev, current, i, arr) => {
            const or = 'یا'
            const comma = '،'
            if (!prev) return current
            if (i === arr.length - 1) return `${prev} ${or} ${current}`
            return `${prev}${comma} ${current}`
          }, '')

          return `با ${actionsStr} شروع کنید!`
        },
      },
      pv: {
        title: 'هنوز پیامی در اینجا نیست...',
        description: 'پیامی ارسال کنید یا روی استیکر خوش آمدگویی بزنید',
      },
    },
  },
  chat: {
    issue: 'رفع اشکال',
    selectARoomToStart: 'برای شروع یکی از گفتگوها را انتخاب کنید',
    dropHereToSend: 'فایل خود را در این قسمت رها کنید',
    vitrine: 'ویترین',
    courseVitrine: 'فهرست دوره',
    generalIssue: 'پرسش و پاسخ',
    event: {
      meetingStarted: (userId: string) => [
        getUserToken(userId),
        getTextToken('جلسه را آغاز کرد'),
      ],
      liveStarted: () => [getTextToken('پخش زنده شروع شد')],
      classStarted: () => [getTextToken('کلاس آنلاین شروع شد')],
      tribuneStarted: () => [getTextToken('تریبون شروع شد')],
      joinedGroupViaLink: (userId: string) => [
        getUserToken(userId),
        getTextToken('از طریق لینک به گروه پیوست'),
      ],
      joinedGroup: (userId: string) => [
        getUserToken(userId),
        getTextToken('به گروه پیوست'),
      ],
      leaveGroup: (userId: string) => [
        getUserToken(userId),
        getTextToken('گروه را ترک کرد'),
      ],
      signUpContact: (userId: string) => [
        getUserToken(userId),
        getTextToken('به پنل کاربری آلفا اسکول پیوست'),
      ],
      addToGroup: (
        doerUserId: string,
        affectedUserId: string,
        isGroup: boolean,
      ) => [
        getUserToken(affectedUserId),
        getTextToken('توسط'),
        getUserToken(doerUserId),
        getTextToken(` به ${isGroup ? 'گروه' : 'کانال'} اضافه شد`),
      ],
      removeFromGroup: (
        doerUserId: string,
        affectedUserId: string,
        isGroup: boolean,
      ) => [
        getUserToken(affectedUserId),
        getTextToken('توسط'),
        getUserToken(doerUserId),
        getTextToken(` از ${isGroup ? 'گروه' : 'کانال'} حذف شد`),
      ],
      pinnedMessage: (userId: string, messageIid: number) => [
        getUserToken(userId),
        getTextToken(' «'),
        getMessageToken(messageIid),
        getTextToken(userId ? '» را سنجاق کرد' : '» سنجاق شد'),
      ],
      youJoinedChannel: 'شما به این کانال پیوستید',
    },

    sendVoiceDialog: {
      title: 'پیام صوتی',
      record: {
        title: 'صدای خود را ضبط کنید',
        save: 'ذخیره',
        cancel: 'لغو',
        recording: 'در حال ضبط صدا',
        restart: 'شروع مجدد',
      },
    },

    // TODO: CHECK THIS FORM OF LOCALIZATION
    meetingStarted: 'جلسه را آغاز کرد',
    meetingEnded: 'جلسه به پایان رسید',
    liveStarted: 'پخش زنده شروع شد',
    classStarted: 'کلاس آنلاین شروع شد',
    liveEnded: 'پخش زنده به پایان رسید',
    classEnded: 'کلاس آنلاین به پایان رسید',
    tribuneStarted: 'تریبون شروع شد',
    tribuneEnded: 'تریبون به پایان رسید',
    joinedGroupViaLink: (name: string) => `${name} از طریق لینک به گروه پیوست`,
    signUpContact: 'به پنل کاربری آلفا اسکول پیوست',
    joinGroup: 'به گروه پیوست',
    leaveGroup: 'گروه را ترک کرد',
    addToGroup: (
      isGroup: boolean,
      doerUserName: string,
      affectedUserName: string,
    ) =>
      `${affectedUserName} توسط ${doerUserName} به ${
        isGroup ? 'گروه' : 'کانال'
      } اضافه شد`,
    removeFromGroup: (
      isGroup: boolean,
      doerUsername: string,
      affectedUsername: string,
    ) =>
      `${affectedUsername} توسط ${doerUsername} از ${
        isGroup ? 'گروه' : 'کانال'
      } حذف شد`,
    pinnedMessage: (doerUserName: string, message: string) =>
      `${doerUserName || ''} «${message}» ${
        doerUserName ? 'را سنجاق کرد' : 'سنجاق شد'
      }`,
    createHall: 'راه اندازی شد',
    removeHallImage: (isGroup: boolean) =>
      `عکس ${isGroup ? 'گروه' : 'کانال'} پاک شد`,
    changeHallImage: (isGroup: boolean) =>
      `عکس ${isGroup ? 'گروه' : 'کانال'} تغییر کرد`,
    changeHallName: (isGroup: boolean, hallNewName: string) =>
      `نام ${isGroup ? 'گروه' : 'کانال'} به «${hallNewName}» تغییر کرد`,
    typing: 'در حال نوشتن',
    recordingVoice: 'در حال ضبط صدا...',
    uploadingVoice: 'در حال بارگذاری صدا...',
    uploadingVideo: 'در حال بارگذاری ویدیو...',
    uploadingFile: 'در حال بارگذاری فایل...',
    uploadingPhoto: 'در حال بارگذاری عکس...',
    uploadingAudio: 'در حال بارگذاری فایل صوتی...',
    tooManyOtherPeople: 'و چند نفر دیگر...',
    editMessage: 'ویرایش پیام',
    sendField: 'پیام بنویسید...',
    sendFieldCaption: 'نوشتن توضیحات...',
    sendImage: 'ارسال عکس',
    sendVideo: 'ارسال ویدیو',
    editImage: 'ویرایش عکس',
    editVideo: 'ویرایش ویدیو',
    recording: 'در حال ضبط',
    processing: 'در حال پردازش',
    replaceFile: 'جایگزینی فایل',
    replacement: 'جایگزینی',
    mute: 'بی‌صدا کردن',
    unMute: 'صدادار کردن',
    pinned: 'پیام سنجاق شده',
    aMessage: 'یک پیام',
    forward: 'هدایت',
    compressing: 'در حال فشرده‌سازی',
  },
  sendField: {
    brightness: 'آشکارسازی',
    contrast: 'کنتراست',
    saturation: 'شدت رنگ',
    hue: 'طیف رنگ',
    refresh: 'بازنشانی',
    upperQuality: 'کیفیت بالاتر',
    lessVolume: 'حجم کمتر',
  },
  feedbackDetailsDialog: {
    title: 'ثبت بازخورد',
    inputLabel: 'به چه مشکلی برخورد کردید؟',
    inputPlaceholder: 'توضیحات خودتان را وارد کنید',
  },
  requestToJoinHallDialog: {
    confirmText: 'ارسال درخواست عضویت',
    description: type =>
      `این ${
        type === 'CHANNEL' ? 'کانال' : 'گروه'
      } فقط پس از تایید توسط ادمین مشترک جدید می‌پذیرد`,
    subtitle: type => `${type === 'CHANNEL' ? 'کانال' : 'گروه'} خصوصی`,
  },
  callRoomIsFullDialog: {
    title: callName => `ظرفیت ${callName} تکمیل است`,
    description: callName =>
      `متأسفانه ظرفیت این ${callName} به حد نصاب رسیده و در حال حاضر امکان ورود وجود ندارد.`,
    submitText: 'متوجه شدم',
  },
  vodIsOverDialog: {
    title: 'ظرفیت دوره تکمیل است',
    description:
      'برای افزایش ظرفیت یا تمدید دسترسی، لطفاً با ادمین دوره تماس بگیرید.',
    submitText: 'متوجه شدم',
  },
  call: {
    incomingCall: 'تماس پنل کاربری آلفا اسکول...',
    connecting: 'در حال برقراری ارتباط...',
    ongoingCalls: {
      call: 'تماس در جریان',
      meeting: 'جلسه در جریان',
      live: 'پخش زنده در جریان',
      tribune: 'تریبون در جریان',
      classroom: 'کلاس آنلاین در جریان',
    },
    voiceCall: 'گفتگوی صوتی',

    group_call: 'جلسه',
    live: 'پخش زنده',
    tribune: 'تریبون',
    call: 'تماس',
    classroom: 'کلاس آنلاین',

    class: 'کلاس',

    watch: 'مشاهده',
    enter: 'ورود',
    join: 'پیوستن',
    leave: 'ترک',
    notification: 'اطلاع رسانی',
    startNow: 'شروع همین الان',

    startsAtDate: 'برگزاری در ',
    startsFrom: 'تا شروع',
    inProgress: 'در حال برگزاری',

    cancel: 'انصراف',
    accept: 'پذیرفتن',
    reject: 'رد کردن',
    retry: 'تلاش مجدد',
    callAgain: 'تماس مجدد',

    busy: 'خط مشغول است',
    ended: 'مکالمه تمام شد',
    rejected: 'رد تماس توسط مخاطب',
    'timed-out': 'مخاطب در دسترس نیست',
    canceled: 'لفو تماس توسط مخاطب',

    scheduledCallNotificationMessage: (
      type,
      startsAt,
      roomType,
      name,
      inviteLink,
    ) => {
      const firstRow = name
        ? `🔶 ${type} با عنوان ${name} در ${startsAt} برگزار خواهد شد.`
        : `🔶 ${type} در ${startsAt} برگزار خواهد شد.`
      return !inviteLink
        ? firstRow
        : `${firstRow} از لینک زیر به ${roomType} برگزاری آن بپیوندید:
${inviteLink}`
    },
    scheduledCallEventMessage: (
      callType: string,
      date: string,
      userName?: string,
    ) =>
      typeof userName === 'string'
        ? `${userName}${callType} را برای تاریخ ${date}، زمان بندی کرد`
        : `${callType} برای تاریخ ${date}، زمان بندی شد`,

    callFeedbackDialog: {
      title: (callTypeString: string, callType: string) =>
        `به کیفیت ${
          callType === 'tribune' ? 'صدا' : 'صدا و تصویر'
        } در این ${callTypeString} چه نمره‌ای می‌دهید؟`,
      qualityDescriptors: {
        veryBad: 'خیلی بد',
        bad: 'بد',
        normal: 'معمولی',
        good: 'خوب',
        veryGood: 'خیلی خوب',
      },
      problems: {
        title: 'مشکل کجا بود؟',
        noImage: 'تصویر را نداشتم',
        disconnectingAndConnectingTheImage: 'قطع و وصلی تصویر',
        noAudio: 'صدا را نداشتم',
        disconnectingAndConnectingTheAudio: 'قطع و وصلی صدا',
      },
      inputPlaceholder: 'مشکل خودتان را در صورت لزوم توضیح دهید',
      confirm: 'تایید',
    },

    status: {
      common: {
        busy: 'تماس ناموفق',
        rejected: 'تماس رد شد',
        canceled: 'تماس لغو شده',
      },
      opponent: {
        successful: 'تماس دریافتی',
        'timed-out': 'عدم پاسخگویی',
      },
      me: {
        successful: 'تماس موفق',
        'timed-out': 'تماس از دست رفته',
      },
    },
  },
  accounts: {
    deletedAccount: 'حساب کاربری حذف شده',
    deletedAccountAvatarText: 'ح‌ح',
    recentUserDeletedAccount: 'کاربر حذف شده',
  },
  contextMenu: {
    limitedByAdmin: (isGroup: boolean) =>
      `قابلیت کپی و ارسال به دیگران در ${
        isGroup ? 'گروه' : 'کانال'
      } توسط ادمین بسته شده است`,
    reply: 'پاسخ',
    forward: 'ارسال به دیگران',
    copyLink: 'کپی لینک',
    saveToDownloads: 'ذخیره در دانلودها',
    showSharedMedia: 'نمایش تمامی رسانه‌ها',
    haveSeen: (count: number) =>
      count > 1
        ? `${toLocale(count)} نفر دیده‌اند `
        : `${toLocale(1)} نفر دیده‌است `,
  },
  forceUpdateTwa: {
    title: `بروزرسانی جدید ${APP_NAME}`,
    description:
      'نسخه فعلی دیگر پشتیبانی نمی‌گردد، لطفا نسخه جدید را دریافت و نصب کنید.',
    button: 'دریافت نسخه جدید',
  },
  validation: {
    invitationLink: {
      leastChars: 'لینک دعوت باید حداقل ۵ کاراکتر باشد.',
      notSupportedChars: 'فقط حروف و اعداد انگلیسی و علامت _ مجاز است.',
      notStartWithLetter: 'لینک دعوت باید با حرف شروع شود.',
      exists: 'لینک دعوت وارد شده تکراری است.',
      isAvailable: 'این لینک دعوت معتبر است.',
    },
    username: {
      leastChars: 'نام کاربری باید حداقل ۵ کاراکتر باشد.',
      notSupportedChars: 'فقط حروف و اعداد انگلیسی و علامت _ مجاز است.',
      notStartWithLetter: 'نام کاربری باید با حرف شروع شود.',
      exists: 'نام کاربری وارد شده تکراری است.',
      isAvailable: 'این نام کاربری معتبر است.',
    },
  },
  snackbar: {
    voiceRecorder: {
      alreadyRecording: 'شما از قبل در حال ضبط هستید',
    },
    failedToLoadUserWorkspaces: 'دریافت فضای اختصاصی با مشکل مواجه شد',
    hallsMovedToWorkspace: 'گفت‌وگوها با موفقیت به فضای اختصاصی منتقل شدند',
    hallsRemovedFromWorkspace: 'گفت‌وگوها با موفقیت از فضای اختصاصی حذف شدند',
    phoneNumberIsNotSignedUp: 'شماره همراه شما ثبت نام نکرده است',
    workspaceUpdated: 'فضای اختصاصی با موفقیت به روز شد',
    workspaceDeleted: 'فضای اختصاصی با موفقیت حذف شد',
    workspaceCreated: 'فضای اختصاصی با موفقیت ایجاد شد',
    trialIsActivatedOnce: 'نسخه آزمایشی پیش از این برای شما فعال شده است.',
    trialCantBeActivatedBecauseOfActivatedPlans:
      'با توجه به خرید بسته های پنل کاربری آلفا اسکول امکان فعال سازی نسخه آزمایشی وجود ندارد.',
    callRoomIsFull: (callType: string) => `ظرفیت ${callType} تکمیل شده است`,
    trialStartedSuccessfully: 'دموی نسخه ویژه برای شما فعال شد.',
    failedToStartTrial:
      'فعال‌سازی نسخه آزمایشی با مشکل مواجه شد. لطفا مجددا تلاش کنید',
    requestForPremiumPlanSentSuccessfully:
      'درخواست شما ثبت شده است. \n' +
      'بزودی کارشناسان ما با شما ارتباط میگیرند.',
    yourTrialHasExpired: 'مدت استفاده رایگان شما  تمام شده است',
    invite: {
      error: {
        FORBIDDEN: 'شما اجازه‌ی دعوت ندارید',
        EXCEEDS_CAPACITY: 'تعداد شماره‌ها بیشتر از ظرفیت دعوت شماست',
      },
      successfully: (invited: string, registered: string) =>
        `${invited ? `${invited} نفر با موفقیت دعوت شدند.` : ''}  ${
          registered
            ? `${registered} نفر از افرادی که دعوت کردید پیش از این ثبت نام کرده بودند.`
            : ''
        }`,
      noOneInvited: 'هیچ دعوتی با موفقیت انجام نشد',
    },
    couldntJoinClass:
      'در پیوستن به کلاس مشکلی پیش آمده است. لطفا دوباره تلاش کنید.',
    switchSyncContactActivation: (activated: boolean) =>
      `مخاطبین این دستگاه به این حساب کاربری اضافه ${activated ? 'خواهد' : 'نخواهد'} شد.`,
    invalidStoryFileType:
      'نوع فایل انتخابی شما برای اطلاع رسانی پشتیبانی نمی‌شود',
    inviteLinkSentSuccessfully: 'لینک دعوت برای مخاطبین ارسال شد',
    joinRequestSentSuccessfully: 'درخواست عضویت با موفقیت ارسال شد',
    youHaveAlreadyRequestedToJoin: 'شما قبلاً درخواست عضویت داده‌اید',
    joinRequestAccepted: userName => `${userName} با موفقیت به کانال پیوست`,
    joinRequestRejected: userName => `درخواست ${userName} رد شد`,
    failedToAcceptJoinRequest: userName =>
      `تایید درخواست عضویت ${userName} با مشکل مواجه شد`,
    failedToRejectJoinRequest: userName =>
      `رد درخواست عضویت ${userName} با مشکل مواجه شد`,
    incomingCallAcceptedFromAnotherDevice:
      'تماس در یکی دیگر از دستگاه‌های شما پاسخ داده شد.',
    usernameIsInvalid: 'نام کاربری مورد نظر پیدا نشد',
    maxCharacterInTextMessageReached:
      'شما به بیشترین حد استفاه از کاراکتر در یک پیام متنی رسیده‌اید.',
    maxCharacterInCaptionReached:
      'شما به بیشترین حد استفاه از کاراکتر در یک زیرمتن رسیده‌اید.',
    syncedContactsClearedSuccessfully: 'مخاطبین شما حذف شد',
    reloadingContactsInProgress: 'در حال بروزرسانی مخاطبین',
    ContactsReloadedSuccessfully: 'بروزرسانی مخاطبین با موفقیت انجام شد',
    maximumNumberOfHallAdminsExceeded: limit =>
      `حداکثر ${limit} نفر میتوانند مدیر باشند.`,
    noForwardPermission: {
      text: 'شما اجازه ارسال به این چت را ندارید',
    },
    fileMessageSizeLimitExceeded: maximumSize =>
      `حجم فایل ارسالی نمیتواند بیشتر از ${maximumSize} مگابایت باشد!`,
    call: {
      userBanned: (callType: string) =>
        `دسترسی شما به این ${callType} ممنوع شده است`,
      requestFailed: 'درخواست شما با مشکل مواجه شد. لطفا دوباره تلاش کنید.',

      joinFailed: (callType: string) =>
        `در پیوستن به ${callType} مشکلی پیش آمده است. لطفا دوباره تلاش کنید.`,
      roomIsFull: `متاسفانه ظرفیت کلاس به اتمام رسیده است`,

      startFailed: (callType: string) =>
        `شروع ${callType} با مشکل مواجه شد. لطفا دوباره تلاش کنید.`,

      noInternetConnection: 'لطفا اتصال اینترنت خود را بررسی کنید.',

      edited: type => `${type} با موفقیت ویرایش شد`,
      deleted: type => `زمان‌بندی ${type} حذف شد`,
    },
    noPermissionToSend: {
      text: 'شما اجازه ارسال پیام در این گفت‌و‌گو را ندارید',
    },
    identifierNotExist: {
      text: 'شناسه مورد نظر وجود ندارد',
    },
    connectionProblem: {
      text: 'مشکلی در اتصال به سرور وجود دارد',
    },
    genImageFailed: {
      text: 'تولید تصویر موردنظر با مشکل مواجه شده است',
    },
    genTextFailed: {
      text: 'تولید متن موردنظر با مشکل مواجه شده است',
    },
    operationFailed: {
      text: 'مشکلی در انجام عملیات رخ داده است',
    },
    newUpdateIsAvailable: {
      text: 'نسخه‌ی جدید دریافت شده است!',
      actionText: 'راه اندازی',
    },
    installPWAPrompt: {
      text: 'نصب اپلیکیشن',
      actionText: 'دریافت',
    },
    thereIsAProblemInConnection: {
      text: 'مشکلی در اتصال وجود دارد',
    },
    inviteLinkExpired: {
      text: 'لینک دعوت باطل شد',
    },
    invalidLink: {
      text: 'لینک معتبر نیست',
    },
    nMemberRemovedFromHall: {
      text: (count: string, type: string) => `${count} عضو از ${type} حذف شد`,
    },
    canNotAccessViaForwardedMessage: {
      text: 'حساب کاربری توسط کاربر پنهان شده است',
    },
    historyWasCleared: {
      text: 'تاریخچه‌ی گفت‌و‌گو پاک شد',
    },
    chatsRemoved: {
      text: 'گفت‌وگوها حذف شدند',
    },
    chatRemoved: {
      text: 'گفت‌وگو حذف شد',
    },
    textSavedInMemory: {
      text: 'متن در حافظه ذخیره شد',
    },
    linkSavedInMemory: {
      text: 'لینک در حافظه ذخیره شد',
    },
    hashtagSavedInMemory: {
      text: 'هشتگ در حافظه ذخیره شد',
    },
    phoneNumberSavedInMemory: {
      text: 'شماره‌ی همراه در حافظه ذخیره شد',
    },
    reportSent: {
      text: 'گزارش با موفقیت ثبت شد',
    },
    bioSavedInMemory: {
      text: 'معرفی کوتاه در حافظه ذخیره شد',
    },
    usernameSavedInMemory: {
      text: 'نام کاربری در حافظه ذخیره شد',
    },
    userBanned: {
      text: 'کاربر مسدود شد',
    },
    userUnbanned: {
      text: 'کاربر رفع مسدودیت شد',
    },
    uploadingImage: {
      text: 'تصویر در حال بارگذاری است',
    },
    userRemovedFromYourContact: {
      text: {
        postfix: 'از مخاطبین شما حذف شد',
      },
    },
    userPromotedToAdmin: {
      text: {
        postfix: 'به مدیر ارتقا یافت',
      },
    },
    userRemovedFromRoom: {
      text: {
        postfix: {
          prefix: 'از',
          postfix: 'حذف شد',
        },
      },
    },
    nMessageForwardedToChat: {
      text: (multipleMessage: boolean, count: string) =>
        `پیام‌${multipleMessage ? 'ها' : ''} به ${count} گفت‌و‌گو هدایت ${
          multipleMessage ? 'شدند' : 'شد'
        }`,
    },
    selectionLimit: {
      text: (count: number) =>
        `انتخاب بیشتر از ${toLocale(count)} نفر مجاز نیست`,
    },
    sharedSuccessfully: 'پیام شما با موفقیت ارسال شد',
    pinnedSuccessfully: 'پیام سنجاق شد',
    unPinnedSuccessfully: 'سنجاق پیام برداشته شد',
    messageNotExist: 'پیام وجود ندارد',
    pinRoomLimit: {
      text: `متاسفانه نمیتوانید بیش از ${toLocale(
        LIMITS.pinnedRoomsCount,
        false,
      )} گفت‌وگو را سنجاق کنید`,
    },
  },
  roomPins: {
    pinned: (count: number) => `${toLocale(count)} پیام سنجاق شده`,
    removeAllPins: 'برداشتن سنجاق تمامی پیام‌ها',
  },
  activeSessions: {
    currentDevice: 'دستگاه فعلی',
    deactivateOtherDevices: 'غیرفعال کردن دستگاه‌های دیگر',
    otherActiveDevices: 'سایر دستگاه‌های فعال',
    unknownInformation: 'اطلاعات نامشخص',
    terminateSession: 'پایان دادن به نشست',
    showMore: (count: number) => `نمایش ${count} دستگاه دیگر`,
    loadFailed: 'دریافت فهرست دستگاه‌ها ممکن نشد. لطفا دوباره تلاش کنید.',
    tooManyRequests:
      'تعداد درخواست‌ها زیاد بوده است. لطفا چند دقیقه دیگر دوباره تلاش کنید.',
  },
  invalidLinkModal: {
    title: 'لینک کلاس اشتباه است',
    description: 'لینک کلاس وارد شده معتبر نمی‌باشد. لطفا دوباره تلاش کنید.',
    confirmText: 'تغییر لینک',
    cancelText: 'رد کردن',
  },
  iosCallProblemsModal: {
    description:
      'کاربر عزیز، با توجه به سیستم عامل گوشی شما (iOS) ممکن است که این سامانه با مشکلاتی مواجه شود. آیا از ورود به این سامانه اطمینان دارید؟',
    confirmText: 'ورود به نسخه آزمایشی',
  },
  chooseChannelCallModal: {
    title: 'ابزار مورد نظر را انتخاب کنید:',
    groupCallDescription: 'برگزاری جلسات گروهی',
    liveDescription: 'برگزاری رویدادهای تصویری',
    tribuneDescription: 'برگزاری رویدادهای صوتی',
    classroomDescription:
      'ابزار حرفه‌ای برگزاری کلاس آنلاین با قابلیت‌های گفت و گو، ضبط و استفاده از ابزارهای دیگر',
    callLimit: (limit: number) => `محدودیت: ${toLocale(limit)} نفر`,
  },
  chooseHallCallTimeModal: {
    creatingCall: {
      tribune: 'برگزاری تریبون',
      meeting: 'برگزاری جلسه',
      live: 'برگزاری پخش زنده',
      classroom: 'برگزاری کلاس آنلاین',
    },
    editingCall: {
      tribune: 'ویرایش زمانبندی تریبون',
      meeting: 'ویرایش زمانبندی جلسه',
      live: 'ویرایش زمانبندی پخش زنده',
      classroom: 'ویرایش زمانبندی کلاس آنلاین',
    },
    schedulingCall: {
      tribune: 'زمانبندی تریبون',
      meeting: 'زمانبندی جلسه',
      live: 'زمانبندی پخش زنده',
      classroom: 'زمانبندی کلاس آنلاین',
    },
    title: 'عنوان',
    titleError: {
      tribune: 'عنوان تریبون نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      group_call: 'عنوان جلسه نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      live: 'عنوان پخش زنده نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      classroom: 'عنوان کلاس آنلاین نمی‌تواند کمتر از ۳ کاراکتر باشد.',
    },
    titlePlaceholder: 'عنوان را وارد کنید',
    startTime: 'زمان شروع',
    selectStartTime: 'انتخاب زمان شروع',
    sendNotificationInChannel: 'ارسال پیام اطلاع‌رسانی در کانال',
    sendNotificationInGroup: 'ارسال پیام اطلاع‌رسانی در گروه',
    delete: 'حذف',
    save: 'ذخیره',
    start: 'شروع',
    startNow: 'شروع همین الان',
    scheduleForLater: 'زمان بندی برای بعد',
    startAtChosenDate: 'شروع در زمان انتخاب شده',
    optional: 'اختیاری',
  },
  toolBoxModal: {
    contact: 'مخاطب',
    header: 'جعبه ابزار',
    actions: {
      image: 'عکس',
      video: 'ویدیو',
      file: 'فایل',
      location: 'موقعیت',
      contact: 'مخاطب',
    },
  },
  bookmarkModal: {
    management: 'مدیریت',
    bookmark: 'نشان کردن',
    bookmarked: 'نشان شده',
    report: 'گزارش',
    remove: 'حذف محتوا',
    edit: 'ویرایش محتوا',
  },
  shareWappModal: {
    shareInSahab: 'ارسال به دیگری در پنل کاربری آلفا اسکول',
    shareOutOfSahab: 'ارسال در سایر شبکه‌های اجتماعی',
    copy: 'رونوشت لینک مستقیم',
  },
  seenListModal: {
    today: 'امروز در ',
    yesterday: 'دیروز در ',
    customDate: (date: string, time: string) => `
      ${date} در ${time}  
    `,
  },
  bookmarkSelectionListModal: {
    noList: 'فهرستی وجود ندارد',
    shouldMakeAList: 'برای اضافه کردن محتوا یک فهرست ایجاد کنید',
    contentCount: (count: number) => `${toLocale(count)} محتوا`,
    noContent: 'بدون محتوا',
    createCollection: 'ایجاد فهرست',
    editCollection: 'ویرایش فهرست',
    add: 'افزودن',
  },
  bookmarkMakeListModal: {
    title: 'عنوان فهرست',
    placeholder: 'عنوان فهرست را وارد کنید',
    shouldNotBeEmpty: 'عنوان فهرست را وارد کنید',
  },
  permissionModal: {
    mic: 'میکروفون',
    camera: 'دوربین',
    notifications: 'اعلان‌ها',
    contacts: 'مخاطبان',
    promptTitle: (name: string) => `دسترسی برای ${name}`,
    deniedTitle: (name: string) => `عدم دسترسی به ${name}`,
    promptDescription: (name: string) =>
      `به منظور فعال‌سازی ${name}، روی ادامه زده و بعد گزینه allow رو انتخاب کنید`,
    deniedDescription: (name: string) =>
      `شما مجوز دسترسی به ${name} را به پنل کاربری آلفا اسکول نداده‌اید. برای راهنمایی بیشتر به منظور فعال کردن ${name}، روی اطلاعات بیشتر بزنید.`,
    cameraDeniedDescription:
      'شما مجوز دسترسی به دوربین را به پنل کاربری آلفا اسکول نداده‌اید.',
    infoOption: 'اطلاعات بیشتر',
    updateTwaVersion: {
      title: 'انتشار نسخه جدید اندروید',
      description:
        'نسخه جدید اندروید منتشر شده است، همین الان آن را دریافت و نصب کنید!',
      confirmOption: 'دریافت و نصب',
      cancelOption: 'بعدا',
    },
    clockMismatch: {
      title: 'عدم تطابق ساعت',
      description:
        'کاربر عزیز، ساعت دستگاه شما مطابق با ساعات رسمی کشور نیست و نیازمند اصلاح است. برای دیدن نحوه اصلاح آن، وارد لینک زیر شوید.',
    },
    notification: {
      teacher: {
        title: 'هیچ اعلانی را از دست ندهید!',
      },
      student: {
        title: 'از هیچ اعلانی جا نمونی!',
      },
      description:
        'برای دسترسی به تمامی امکانات این برنامه، در پنجره‌ باز شده در ادامه، گزینه "Allow" را بزنید',
      activate: 'فعال کردن اعلان‌ها',
    },
    notYet: 'فعلا نه',
    contact: {
      teacher: {
        title: 'دوستان و آشنایان خود را پیدا کنید!',
      },
      student: {
        title: 'هم‌کلاسی‌ها و معلم‌های خودت رو پیدا کن!',
      },
      description:
        'برای دسترسی به به لیست مخاطبین خود، در پنجره باز شده در ادامه، گزینه "Allow" را بزنید',
      activate: 'اجازه دسترسی به مخاطبین',
    },
  },
  baleChannelPromotion: {
    title: 'کانال بله آلفا اسکول',
    description:
      'از اخبار کنکور بگیر تا برنامه‌ریزی درسی! همه اینا در کانال بله آلفا. برای عضویت کلیک کن!',
    join: 'عضو می‌شم!',
  },
  premiumFeatureModal: {
    buy: 'خرید بسته ویژه',
    testFreeForNDays: (n: number) => `${toLocale(n)} روز رایگان امتحان کنید`,
    features: {
      All: {
        title: 'نسخه ویژه',
        description:
          'همه نیازهای آموزشی شما در یک پلتفرم جامع کلاس آنلاین، دوره ویدیوئی، آزمون و ...',
      },
      CourseVitrine: {
        title: 'ابزار فهرست دوره',
        description: 'فعال کردن فهرست تنها توسط کاربران ویژه امکان پذیر است.',
      },
      QuestionAndAnswer: {
        title: 'ابزار پرسش',
        description: 'فعال کردن پرسش تنها توسط کاربران ویژه امکان پذیر است.',
      },
      ProtectContent: {
        title: 'محدود کردن ارسال به دیگران',
        description:
          'فعال کردن محدودیت ارسال تنها توسط کاربران ویژه امکان پذیر است.',
      },
      Classroom: {
        title: 'ابزار کلاس آنلاین',
        description:
          'برای استفاده از کلاس آنلاین، لازم است کاربری ویژه خریداری کنید.',
      },
      Story: {
        title: 'اطلاع رسانی',
        description:
          'برای استفاده از اطلاع رسانی در کانال، لازم است کاربری ویژه خریداری کنید.',
      },
      UserStory: {
        title: 'اطلاع رسانی',
        description:
          'برای استفاده از اطلاع رسانی، لازم است کاربری ویژه خریداری کنید.',
      },
      VodActivated: {
        title: 'بارگزاری ویدئو با حجم بالا',
        description:
          'برای استفاده از بازگزاری ویدیو با حجم بالا، لازم است کاربری ویژه خریداری کنید.',
      },
      HideMemberCount: {
        title: 'پنهان کردن تعداد مشترکین کانال',
        description:
          'برای پنهان کردن تعداد مشترکین کانال، لازم است کاربری ویژه خریداری کنید.',
      },
      UserSessionsLimit: {
        title: 'محدودیت تعداد نشست کاربران',
        description:
          'برای محدود کردن تعداد نشست کاربران، لازم است کاربری ویژه خریداری کنید.',
      },
      Recording: {
        title: 'قابلیت ضبط',
        description:
          'برای فعال سازی قابلیت ضبط، لازم است کاربری ویژه خریداری کنید.',
      },
      Vod: {
        title: 'دوره آفلاین',
        description:
          'برای برگزاری دوره‌های آفلاین، لازم است کاربری ویژه خریداری کنید.',
      },
      Workspace: {
        title: 'ایجاد فضای اختصاصی',
        description:
          'امکان ایجاد یک محیط آموزشی منحصر به فرد و متناسب با نیازهای خاص شما.',
      },
      OfflineCourse: {
        title: 'دوره آفلاین',
        description:
          'برای برگزاری دوره‌های آفلاین، لازم است کاربری ویژه خریداری کنید.',
      },
    },
  },
  packageLimitReachedModal: {
    types: {
      JoinChannel: {
        title: 'ظرفیت دوره تکمیل است',
        description:
          'برای افزایش ظرفیت یا تمدید دسترسی، لطفاً با ادمین دوره تماس بگیرید.',
      },
      AddMembers: {
        title: 'ظرفیت دوره تکمیل است',
        description:
          'برای افزایش ظرفیت یا تمدید دسترسی، از طریق داشبورد مصرف اقدام به خرید بسته دوره آفلاین کنید.',
      },
      UploadToVod: {
        title: 'ظرفیت دوره تکمیل است',
        description:
          'بسته آفلاین شما به پایان رسیده است. می‌توانید از طریق داشبورد مصرف، برای خرید بسته دوره آفلاین اقدام فرمایید.',
      },
      Recording: {
        title: 'ظرفیت دوره تکمیل است',
        description:
          'بسته ضبط ابری شما به پایان رسیده است. می‌توانید از طریق داشبورد مصرف، برای خرید بسته ضبط ابری اقدام فرمایید.',
      },
      OnlineClass: {
        title: 'ظرفیت دوره تکمیل است',
        description:
          'بسته کلاس آنلاین شما به پایان رسیده است. می‌توانید از طریق داشبورد مصرف، برای خرید بسته کلاس آنلاین اقدام فرمایید.',
      },
      RemoveAdmin: {
        title: 'ظرفیت دوره تکمیل است',
        description:
          'برای افزایش ظرفیت یا تمدید دسترسی، لطفاً با ادمین دوره تماس بگیرید.',
      },
    },
  },
  startPremiumFeaturesTrialModal: {
    description:
      'همه نیازهای آموزشی شما در یک پلتفرم جامع کلاس آنلاین، دوره ویدیوئی، آزمون و ...',
    confirmText: 'شروع دمو',
    imageAlt: 'فعالسازی دمو',
  },
  wapps: {
    usageDashboard: 'مصرف اشتراک',
    post: 'پست',
    poll: 'نظرسنجی',
    form: 'فرم',
    multipleChoiceExam: 'آزمون تستی',
    descriptiveExam: 'آزمون تشریحی',
    unitTest: 'تک تست',
    homework: 'تکلیف',
    article: 'مقاله',
    kaghaz: 'کاغذ',
    darsnameh: 'درسنامه',
    rooznegar: 'روزنگار',

    meeting: 'جلسه',
    event: 'رویداد',
    blog: 'بلاگ',
    multimedia: 'آثار',
    forum: 'هم‌اندیشی',
    rahkar: 'حرکت',
    unknown: 'ابزار',
    tribune: 'تریبون',
    map: 'موقعیت',
    nevise: 'نویسه',
    generalExam: 'آزمون تستی',
    porsesh: 'پرسش',
    receiptsAdminPanel: 'رسیدهای پرداخت',
  },
  chatListToolbox: {
    title: 'جعبه ابزار',
    otherWapps: 'سایر ابزارها',
    mainItems: {
      generalExam: {
        title: 'آزمون تستی',
        description: 'تک‌درس، چنددرس، جامع',
        buttonText: 'برگزاری آزمون',
      },
      classroom: {
        title: 'کلاس آنلاین',
        description: 'برگزاری کلاس با امکان ضبط ابری',
        buttonText: 'ایجاد کلاس جدید',
      },
      post: {
        title: 'کلاس ویدیوئی',
        description: 'بار‌گذاری ویدیو‌های دوره',
        buttonText: 'بارگذاری ویدیو',
      },
    },
  },

  emojiPicker: emojiPickerI18n,
  errorBoundary: {
    applicationCrashed: 'برنامه با مشکل مواجه شد!',
    tryAgainOrCallSupport:
      'متاسفانه صفحه‌ای که وارد آن شدید دچار خطا شده است، دوباره تلاش  کنید و در صورت تکرار مشکل به پشتیبانی اطلاع دهید',
    contactSupport: 'ارتباط با پشتیبانی',
  },
  warningPages: {
    browserNotSupported: {
      title: 'مرورگر نامناسب',
      useSafari: {
        text1:
          'مرورگری که از آن استفاده می‌کنید پشتیبانی نمی‌شود. برای جلوگیری از مشکلات احتمالی، از مرورگر سافاری',
        text2: 'استفاده کنید',
      },
      useChrome: {
        text1:
          'مرورگری که از آن استفاده می‌کنید پشتیبانی نمی‌شود. برای جلوگیری از مشکلات احتمالی، از مرورگر کروم',
        text2: 'استفاده کنید',
      },
    },
    outdatedBrowser: {
      title: 'مرورگر قدیمی',
      description:
        'نسخه مرورگر شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی نمایید.',
      yourVersion: 'نسخه مرورگر شما',
      minVersion: 'نسخه قابل اجرا',
    },
    outdatedOs: {
      oldAndroid: 'اندروید قدیمی',
      oldIos: 'آی او اس قدیمی',
      updateAndroid:
        'نسخه اندروید شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی یا از دستگاه دیگری استفاده نمایید.',
      updateIos:
        'نسخه آی او اس شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی یا از دستگاه دیگری استفاده نمایید.',
    },
  },
  invite: {
    inviteViaPhone: 'دعوت از طریق شماره موبایل',
    checkboxOption: 'امکان دعوت دیگران را داشته باشد',
    inviteFromContacts: 'دعوت از لیست مخاطبین',
    yourInviter: 'دعوت کننده شما به پلتفرم',
    invited: 'دعوت شدگان',
    accepted: 'پذیرندگان دعوت',
    invitedAt: (date: number) =>
      `در تاریخ ${dateTimeFormatter.format(date)} دعوت شد`,
    invitationStatus: 'ظرفیت دعوت شما: ',
    sms: `سلام و عرض ادب، شما به پلتفرم ${APP_NAME} دعوت شده اید.
    ورود به پلتفرم: ${FRONT_HOST.replace(/(^\w+:|^)\/\//, '')}
    دانلود نسخه اندروید: ${TWA_DOWNLOAD_SRC.replace(/(^\w+:|^)\/\//, '')}`,
    oneUserSms: (
      phone: string,
    ) => `سلام و عرض ادب، شما به پلتفرم ${APP_NAME} دعوت شده اید.
     ${phone}شماره تلفن دعوت شده: 
    ورود به پلتفرم: ${FRONT_HOST.replace(/(^\w+:|^)\/\//, '')}
    دانلود نسخه اندروید: ${TWA_DOWNLOAD_SRC.replace(/(^\w+:|^)\/\//, '')}`,
    increaseCapacity: 'افزایش ظرفیت',
    inviteTeacher: `سلام و درود
می‌خواستم «پنل کاربری آلفا اسکول» رو بهتون معرفی کنم!✌️
اینجا میتونید کانال اختصاصی خودتون رو تاسیس کنید!😍
تو این کانال میتونید آزمون برگزار کنید، محتوای آموزشی بفرستید و از ابزارهای حرفه‌ای و #رایگان پنل کاربری آلفا اسکول استفاده کنید!👌

لینک نصب پنل کاربری آلفا اسکول👇

📱کافه بازار:
https://cafebazaar.ir/app/me.weblite.twa

📱مایکت:
https://myket.ir/app/me.weblite.twa`,
    inviteStudent: `سلام و درود
همین الان «پنل کاربری آلفا اسکول» رو نصب کن!🙌
اینجا کلی کانال درسی خوب پیدا میکنی!😍
تو این کانال‌ها میتونی تو آزمون شرکت کنی، به تک‌تست‌های چالشی جواب بدی و از درسنامه‌های نکته‌دار استفاده کنی!😎

تازه #همش_رایگانه 🎉

بیا از اینجا نصبش کن👇

📱کافه بازار:
https://cafebazaar.ir/app/me.weblite.twa

📱مایکت:
https://myket.ir/app/me.weblite.twa`,
  },
  forward: {
    text: 'پیام',
    wapp: 'اپلیکیشن',
    forwardSameMessages: (num: number, type: string) =>
      `هدایت ${toLocale(num)} ${type}`,
    forward: (num: number) => `هدایت ${toLocale(num)} پیام`,
    from: (name: string) => `از طرف ${name}`,
    fromTwo: (name1: string, name2: string) => `از طرف ${name1} و ${name2}`,
    fromSome: (name1: string, name2: string) =>
      `از طرف ${name1} و ${name2}و ...`,
    nMessages: (num: number) => `${toLocale(num)} پیام`,
    whatUDo: (num: number, src: string) =>
      `تمایل دارید با ${toLocale(num)} پیام از ${src} چه کنید؟`,
    discardForward: 'لغو هدایت',
  },
  shareContact: {
    choose: 'انتخاب مخاطب',
    share: 'اشتراک گذاری مخاطب',
    viewContact: 'مشاهده مخاطب',
  },
}
